import * as Sentry from '@sentry/react'
import * as Helpers from '#/helpers'

export const keys = {
  DROPBOX: process.env.API_KEY_DROPBOX,
  FACEBOOK: process.env.API_KEY_FACEBOOK,
  GOOGLE: process.env.API_KEY_GOOGLE,
  ONEDRIVE: process.env.API_KEY_ONEDRIVE,
}

export const bundles = {
  PRO: {
    keys: {
      confluence: 'appsplus-tabs-pro-confluence',
      jira: 'appsplus-tabs-pro-jira',
    },
    marketplace: {
      confluence: 1225472,
      jira: 1225660,
    },
    title: 'Tabs+ Pro',
    color: '#0052CC',
    bundle: true,
  },
  LITE: {
    keys: {
      confluence: 'appsplus-tabs-lite-confluence',
      jira: 'appsplus-tabs-lite-jira',
    },
    marketplace: {
      confluence: 1225471,
      jira: 1225800,
    },
    title: 'Tabs+ Lite',
    bundle: true,
    utility: true,
  },
  AGILE: {
    keys: {
      confluence: 'appsplus-tabs-agile-confluence',
      jira: 'appsplus-tabs-agile-jira',
    },
    marketplace: {
      confluence: 1225801,
      jira: 1225802,
    },
    title: 'Agile Bundle',
    color: '#FB275D',
    bundle: true,
    included: [
      'AHA',
      'AIRFOCUS',
      'AIRTABLE',
      'AVION',
      'CARDBOARD',
      'CLICKUP',
      'CODA',
      'FLOWMAPP',
      'MONDAY',
      'PRODPAD',
      'PRODUCTBOARD',
      'PRODUCTPLAN',
      'ROADMUNK',
      'SMARTSHEET',
      'STORIESONBOARD',
      'TRELLO',
      'WRIKE',
    ],
  },
  ANALYTICS: {
    keys: {
      confluence: 'appsplus-tabs-analytics-confluence',
      jira: 'appsplus-tabs-analytics-jira',
    },
    marketplace: {
      confluence: 1225803,
      jira: 1225804,
    },
    title: 'Analytics Bundle',
    color: '#5243AA',
    bundle: true,
    included: [
      'CHARTBLOCKS',
      'GOOGLEANALYTICS',
      'GOOGLEDATA',
      'GECKOBOARD',
      'HOTJAR',
      'MATOMO',
      'METABASE',
      'MIXPANEL',
      'MSPOWERBI',
      'NPMCHARTS',
      'OURWORLDINDATA',
      'PLOTLY',
      'STATUSPAGE',
      'TABLEAU',
      'TRADINGVIEW',
      'WOOPRA',
      'ZOHOANALYTICS',
    ],
  },
  CODE: {
    keys: {
      confluence: 'appsplus-tabs-code-confluence',
      jira: 'appsplus-tabs-code-jira',
    },
    marketplace: {
      confluence: 1225806,
      jira: 1225805,
    },
    title: 'Code Bundle',
    color: '#172B4D',
    bundle: true,
    included: [
      'AZURESTATICWEB',
      'AWSAMPLIFY',
      'AWSCLOUDFRONT',
      'AWSS3',
      'BITBUCKETSNIPPETS',
      'CLOUDFLAREPAGES',
      'CODEPEN',
      'CODESANDBOX',
      'DIGITALOCEAN',
      'EXPOSNACK',
      'FIREBASE',
      'GITBOOK',
      'GITHUBGIST',
      'GITHUBPAGES',
      'GITLABPAGES',
      'GITLABSNIPPETS',
      'GRAPHQL',
      'HEROKU',
      'JSFIDDLE',
      'JSON',
      'KOTLIN',
      'NETLIFY',
      'README',
      'RENDER',
      'REPLIT',
      'STATUSPAGE',
      'STORYBOOK',
      'SWAGGER',
      'VERCEL',
    ],
  },
  DESIGN: {
    keys: {
      confluence: 'appsplus-tabs-design-confluence',
      jira: 'appsplus-tabs-design-jira',
    },
    marketplace: {
      confluence: 1225516,
      jira: 1225807,
    },
    title: 'Design Bundle',
    color: '#00875A',
    bundle: true,
    included: [
      '3DVIEWER',
      'ABSTRACT',
      'ADOBEXD',
      'AXURE',
      'CANVA',
      'COLLABOARD',
      'CONCEPTBOARD',
      'DRAWIO',
      'FIGMA',
      'FRAMER',
      'GLIFFY',
      'GOOGLEDRAWINGS',
      'INVISION',
      'JUSTINMIND',
      'LOTTIEFILES',
      'LUCID',
      'MARVEL',
      'MSDESIGNER',
      'MSVISIO',
      'MINDMEISTER',
      'MIRO',
      'MOCKITT',
      'MOCKPLUS',
      'MOQUPS',
      'MURAL',
      'OCTOPUSDO',
      'OVERFLOW',
      'PROTOIO',
      'PROTOPIE',
      'SKETCH',
      'SKETCHFAB',
      'SKETCHUP',
      'WEBFLOW',
      'WHIMSICAL',
      'ZEPLIN',
    ],
  },
  FILES: {
    keys: {
      confluence: 'appsplus-tabs-files-confluence',
      jira: 'appsplus-tabs-files-jira',
    },
    marketplace: {
      confluence: 1225808,
      jira: 1225809,
    },
    title: 'Files Bundle',
    color: '#006BFF',
    bundle: true,
    included: [
      'AWSS3',
      'BOX',
      'CODA',
      'DROPBOX',
      'GOOGLEDOCS',
      'GOOGLEDRAWINGS',
      'GOOGLEDRIVE',
      'GOOGLESHEETS',
      'GOOGLESLIDES',
      'MSEXCEL',
      'MSPOWERPOINT',
      'MSONEDRIVE',
      'MSWORD',
      'ZOHODOCS',
      'ZOHOSHEET',
      'ZOHOSHOW',
      'ZOHOWORKDRIVE',
      'ZOHOWRITER',
    ],
  },
  FORMS: {
    keys: {
      confluence: 'appsplus-tabs-forms-confluence',
      jira: 'appsplus-tabs-forms-jira',
    },
    marketplace: {
      confluence: 1225810,
      jira: 1225811,
    },
    title: 'Forms Bundle',
    color: '#FF5630',
    bundle: true,
    included: [
      'FORMSITE',
      'FORMSTACK',
      'GOOGLEFORMS',
      'JOTFORM',
      'MSFORMS',
      'PAPERFORM',
      'SURVEYMONKEY',
      'SURVEYSPARROW',
      'TYPEFORM',
      'VIDEOASK',
      'WUFOO',
      'ZOHOFORMS',
      'ZOHOSURVEY',
    ],
  },
  MEETING: {
    keys: {
      confluence: 'appsplus-tabs-meeting-confluence',
      jira: 'appsplus-tabs-meeting-jira',
    },
    marketplace: {
      confluence: 1225812,
      jira: 1225813,
    },
    title: 'Meeting Bundle',
    color: '#8313DD',
    bundle: true,
    included: [
      'CALENDLY',
      'CALENDSO',
      'CHILIPIPER',
      'DESCRIPT',
      'EVENTBRITE',
      'GOOGLECALENDAR',
      'LIVESTORM',
      'LOOM',
      'MSCALENDAR',
      'SAVVYCAL',
      'SLIDO',
      'TELLA',
      'VIDEOASK',
      'VIDYARD',
      'ZOHOMEETING',
      'ZOOM',
    ],
  },
  PRESENTATION: {
    keys: {
      confluence: 'appsplus-tabs-presentation-confluence',
      jira: 'appsplus-tabs-presentation-jira',
    },
    marketplace: {
      confluence: 1225814,
      jira: 1225815,
    },
    title: 'Presentation Bundle',
    color: '#050038',
    bundle: true,
    included: [
      'APESTER',
      'APPLEKEYNOTE',
      'CANVA',
      'COLLABOARD',
      'FLOWVELLA',
      'GOOGLESLIDES',
      'LUDUS',
      'MSPOWERPOINT',
      'MSSTREAM',
      'PITCH',
      'PREZI',
      'SCRIBD',
      'SLIDESHARE',
      'SLIDO',
      'VIMEO',
      'VISME',
      'YOUTUBE',
      'ZOHOSHOW',
    ],
  },
  GOOGLE: {
    keys: {
      confluence: 'appsplus-tabs-google-confluence',
      jira: 'appsplus-tabs-google-jira',
    },
    marketplace: {
      confluence: 1225816,
      jira: 1225817,
    },
    title: 'Google Bundle',
    color: '#4285F4',
    bundle: true,
    included: [
      'GOOGLEANALYTICS',
      'GOOGLECALENDAR',
      'GOOGLEDATA',
      'GOOGLEDOCS',
      'GOOGLEDRAWINGS',
      'GOOGLEDRIVE',
      'GOOGLEFORMS',
      'GOOGLEMAPS',
      'GOOGLESHEETS',
      'GOOGLESLIDES',
    ],
  },
  MICROSOFT: {
    keys: {
      confluence: 'appsplus-tabs-microsoft-confluence',
      jira: 'appsplus-tabs-microsoft-jira',
    },
    marketplace: {
      confluence: 1225818,
      jira: 1225819,
    },
    title: 'Microsoft Bundle',
    color: '#F25022',
    bundle: true,
    included: [
      'MSCALENDAR',
      'MSEXCEL',
      'MSFORMS',
      'MSONEDRIVE',
      'MSPOWERBI',
      'MSPOWERPOINT',
      'MSSTREAM',
      'MSSWAY',
      'MSVISIO',
      'MSWORD',
    ],
  },
  ZOHO: {
    keys: {
      confluence: 'appsplus-tabs-zoho-confluence',
      jira: 'appsplus-tabs-zoho-jira',
    },
    marketplace: {
      confluence: 1225820,
      jira: 1225821,
    },
    title: 'Zoho Bundle',
    color: '#C8202B',
    bundle: true,
    included: [
      'ZOHOANALYTICS',
      'ZOHOCRM',
      'ZOHODOCS',
      'ZOHOFORMS',
      'ZOHOMEETING',
      'ZOHOSHEET',
      'ZOHOSHOW',
      'ZOHOSURVEY',
      'ZOHOWRITER',
      'ZOHOWORKDRIVE',
    ],
  },
}

export const utilities = {
  NOTE: {
    keys: {
      confluence: true,
      jira: true,
    },
    title: 'Note',
    color: '#2684FF',
    utility: true,
    embed: { fullWidth: false },
    embedURL: () => null,
  },
  IMAGE: {
    keys: {
      confluence: true,
      jira: true,
    },
    title: 'Image',
    color: '#FFAB00',
    utility: true,
    domain: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'],
    embed: {
      images: [],
      attribute: false,
      changeable: true,
      noImgDetails: true,
      downloadable: false,
      drag: true,
      scalable: false,
      noFooter: false,
      noLimitInitializationSize: false,
      noNavbar: true,
      noToolbar: false,
      rotatable: false,
      showTotal: false,
      zoomable: true,
    },
    embedURL: (x) => x.url,
  },
  WEBSITE: {
    keys: {
      confluence: true,
      jira: true,
    },
    title: 'Website',
    color: '#FF7452',
    utility: true,
    domain: [],
    embed: {},
    embedURL: (x) => x.url,
  },
  PDF: {
    keys: {
      confluence: true,
      jira: true,
    },
    title: 'PDF',
    color: '#36B37E',
    utility: true,
    domain: [],
    attachments: ['.pdf'],
    embed: {
      attachmentId: null,
      vertical: true,
      toolbar: true,
      download: false,
      bgcolor: '#F4F5F7',
    },
    embedURL: (x) => x.url,
  },
  CODELIVE: {
    keys: {
      confluence: true,
      jira: true,
    },
    title: 'Code',
    color: '#253858',
    utility: true,
    embed: {
      template: 'react',
      theme: 'nightOwl',
      files: null,
      activePath: null,
      display: ['editor', 'console', 'navigation', 'preview', 'refresh'],
    },
    embedURL: () => null,
  },
  WHITEBOARD: {
    keys: {
      confluence: true,
    },
    title: 'Whiteboard',
    color: '#6554C0',
    utility: true,
    embed: {
      data: null,
      lineWidth: 3,
      lineColor: '#0052CC',
      fillColor: '#FFFFFF',
      backgroundColor: '#FFFFFF',
    },
    embedURL: () => null,
  },
}

export const standalone = {
  '3DVIEWER': {
    keys: {
      confluence: 'appsplus-3d-viewer-confluence',
      jira: 'appsplus-3d-viewer-jira',
    },
    marketplace: {
      confluence: 1226700,
      jira: 1226701,
    },
    title: '3D Viewer',
    domain: [],
    attachments: [
      '.obj',
      '.mtl',
      '.3ds',
      '.stl',
      '.ply',
      '.gltf',
      '.glb',
      '.off',
      '.3dm',
      '.fbx',
      '.dae',
      '.wrl',
      '.3mf',
      '.amf',
      '.ifc',
      '.brep',
      '.stp',
      '.step',
      '.igs',
      '.iges',
      '.fcstd',
      '.bim',
    ],
    color: '#0079D9',
    embed: {
      attachmentId: null,
      camera: null,
      backgroundColor: '#FFFFFF',
      defaultColor: '#C8C8C8',
      showEdges: false,
      edgeColor: '#000000',
      edgeThreshold: 1,
      environmentMap: [
        'https://www.appsplus.co/3d/posx.jpg',
        'https://www.appsplus.co/3d/negx.jpg',
        'https://www.appsplus.co/3d/posy.jpg',
        'https://www.appsplus.co/3d/negy.jpg',
        'https://www.appsplus.co/3d/posz.jpg',
        'https://www.appsplus.co/3d/negz.jpg',
      ],
      backgroundIsEnvMap: false,
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
  },
  ABSTRACT: {
    keys: {
      confluence: 'appsplus-abstract-confluence',
      jira: 'appsplus-abstract-jira',
    },
    marketplace: {
      confluence: 1225822,
      jira: 1225823,
    },
    title: 'Abstract',
    domain: ['abstract.com'],
    requires: 'share',
    color: '#191A1B',
    homepage: 'https://www.abstract.com',
    placeholder: 'https://app.abstract.com/share[…]',
    embed: {
      chromeless: false,
    },
    embedURL: (x) =>
      `${x.url
        .replace('share.goabstract.com', 'app.goabstract.com/embed')
        .replace('.com/share', '.com/embed')}${Helpers.encodeParams(x)}`,
    tutorial: [
      'Open an [Abstract] design, click "Share" dropdown',
      'Change sharing settings to "Anyone with the link"',
      'Click "Copy Link to Artboard" and paste above',
    ],
    scribe: 'IWN7_JbmR0GyNkTtrX_0JQ',
  },
  ADOBEXD: {
    keys: {
      confluence: 'appsplus-adobe-xd-confluence',
      jira: 'appsplus-adobe-xd-jira',
    },
    marketplace: {
      confluence: 1225824,
      jira: 1225825,
    },
    title: 'Adobe XD',
    domain: ['xd.adobe.com'],
    color: '#FE2BC1',
    homepage: 'https://assets.adobe.com',
    placeholder: 'https://xd.adobe.com/view/[…]',
    embed: {
      hints: true,
      viewer: false,
    },
    embedURL: (x) =>
      `${x.url.replace(/\?.*$/, '').replace('view', 'embed')}${
        !x.hints ? '?hints=off' : ''
      }`,
    tutorial: [
      'Open [Adobe XD] file and click "Share" tab',
      'Set to "Anyone with the link" then click "Create Link"',
      'On web: open file, copy link in browser bar',
      'Paste the link above',
    ],
    scribe: '-gHoCbGTSGakcWW4-KR2gQ',
  },
  AHA: {
    keys: {
      confluence: 'appsplus-aha-confluence',
      jira: 'appsplus-aha-jira',
    },
    marketplace: {
      confluence: 1225826,
      jira: 1225827,
    },
    title: 'Aha!',
    domain: ['aha.io/shared', 'ideas.aha.io'],
    color: '#0073CF',
    homepage: 'https://aha.io/',
    placeholder: 'https://[...].aha.io/shared/[...]',
    embed: {
      header: false,
      footer: true,
    },
    embedURL: (x) => `${x.url}${Helpers.encodeParams(x, true)}`,
    tutorial: [
      'Open an [Aha!] roadmap, report or note',
      'Create a saved view, click "Share" icon, then "Webpage"',
      '"Enable share as webpage" then "Copy embed code"',
      'Ideas Portal: copy link in browser bar and paste above',
    ],
    scribe: 'L58-O0X_QuWIgwnT8Gyv9A',
  },
  AIRFOCUS: {
    keys: {
      confluence: 'appsplus-airfocus-confluence',
      jira: 'appsplus-airfocus-jira',
    },
    marketplace: {
      confluence: 1225828,
      jira: 1225829,
    },
    title: 'Airfocus',
    domain: ['airfocus.com'],
    color: '#51D7FF',
    homepage: 'https://airfocus.com',
    placeholder: 'https://[...].airfocus.com/share/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open an [Airfocus] view and click "Share"',
      'Create a share link with desired config',
      'Click "Copy URL" and paste link above',
    ],
    scribe: 'JRLP-0Z0RqmKOpjkmP5qEg',
  },
  AIRTABLE: {
    keys: {
      confluence: 'appsplus-airtable-confluence',
      jira: 'appsplus-airtable-jira',
    },
    marketplace: {
      confluence: 1225470,
      jira: 1225830,
    },
    title: 'Airtable',
    domain: ['airtable.com'],
    color: '#18BFFF',
    homepage: 'https://airtable.com',
    placeholder: 'https://airtable.com/[...]',
    embed: {
      backgroundColor: 'blue',
      layout: null,
    },
    embedURL: (x) =>
      `${
        !x.url?.includes('.com/embed')
          ? x.url.replace('.com', '.com/embed')
          : x.url
      }${Helpers.encodeParams(x)}`,
    tutorial: [
      'Open an [Airtable] base',
      'Click "Share" then "Share publicly"',
      'Enable and copy-paste the link above',
    ],
    scribe: 'opE4TKcQQ9iNdt-3uY_h-Q',
  },
  APESTER: {
    keys: {
      confluence: 'appsplus-apester-confluence',
      jira: 'appsplus-apester-jira',
    },
    marketplace: {
      confluence: 1225831,
      jira: 1225832,
    },
    title: 'Apester',
    domain: ['apester.com'],
    color: '#EE2E3C',
    homepage: 'https://apester.com',
    placeholder: 'https://discover.apester.com/media/[...]',
    embed: {
      results: false,
    },
    embedURL: (x) =>
      `${x.url
        .replace('discover.apester.com/media', 'renderer.apester.com/v2')
        .replace(
          'preview.apester.com/media',
          'renderer.apester.com/v2'
        )}?preview=true&results=${x.results}`,
    tutorial: [
      'Open an [Apester] media item',
      'Copy link from browser bar',
      'Paste link above',
    ],
    scribe: 'GZvATn_jTxON-_bkCFSJCA',
  },
  APPLEKEYNOTE: {
    keys: {
      confluence: 'appsplus-apple-keynote-confluence',
      jira: 'appsplus-apple-keynote-jira',
    },
    marketplace: {
      confluence: 1225833,
      jira: 1225834,
    },
    title: 'Apple Keynote',
    domain: ['icloud.com/keynote'],
    color: '#1E69F1',
    homepage: 'https://icloud.com',
    placeholder: 'https://www.icloud.com/keynote/[...]',
    embedURL: (x) => `${x.url.replace(/#.*$/, '')}?embed=true`,
    tutorial: [
      'Save and open your Keynote in [iCloud]',
      'Click top-right menu "Collaborate" profile icon',
      'Set access to "Anyone with the link"',
      'Click "Copy Link" and paste above',
    ],
    scribe: 'dZqc3QJZR3Kcu2VZthdWqA',
  },
  AVION: {
    keys: {
      confluence: 'appsplus-avion-confluence',
      jira: 'appsplus-avion-jira',
    },
    marketplace: {
      confluence: 1226326,
      jira: 1226327,
    },
    title: 'Avion',
    domain: ['avion.io'],
    color: '#E82E72',
    homepage: 'https://www.avion.io',
    placeholder: 'https://[...].avion.io/share/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open an [Avion] story map',
      'Click "Share" in left sidebar',
      'Enable, copy link and paste above',
    ],
    scribe: '0ciQVEL3Tzus4lQ8UTugGw',
  },
  AWSAMPLIFY: {
    keys: {
      confluence: 'appsplus-aws-amplify-confluence',
      jira: 'appsplus-aws-amplify-jira',
    },
    marketplace: {
      confluence: 1225835,
      jira: 1225836,
    },
    title: 'AWS Amplify',
    domain: ['amplifyapp.com'],
    color: '#FF9900',
    homepage: 'https://aws.amazon.com/amplify/',
    placeholder: 'https://[...].amplifyapp.com',
    embedURL: (x) => x.url,
    tutorial: [
      'Login to [AWS Amplify] console',
      'Select a deployed public app',
      'Copy link and paste above',
    ],
    scribe: 'pkmmhYQjQUCsN2khZoabQg',
  },
  AWSCLOUDFRONT: {
    keys: {
      confluence: 'appsplus-aws-cloudfront-confluence',
      jira: 'appsplus-aws-cloudfront-jira',
    },
    marketplace: {
      confluence: 1225837,
      jira: 1225838,
    },
    title: 'AWS CloudFront',
    domain: ['cloudfront.net'],
    color: '#1D9FD6',
    homepage: 'https://aws.amazon.com/cloudfront/',
    placeholder: 'https://[...].cloudfront.net',
    embedURL: (x) => x.url,
    tutorial: [
      'Login to [AWS CloudFront] console',
      'Select a deployed public app',
      'Copy link and paste above',
    ],
    scribe: 'm---9qfyT-G2aPX3iDil9w',
  },
  AWSS3: {
    keys: {
      confluence: 'appsplus-aws-s3-confluence',
      jira: 'appsplus-aws-s3-jira',
    },
    marketplace: {
      confluence: 1225839,
      jira: 1225840,
    },
    title: 'AWS S3',
    domain: ['amazonaws.com'],
    color: '#569A31',
    homepage: 'https://aws.amazon.com/s3/',
    placeholder: 'https://[...].amazonaws.com',
    embedURL: (x) => x.url,
    tutorial: [
      'Login to [AWS S3] console',
      'Set public access bucket policy',
      'Copy link to S3 object and paste above',
    ],
    scribe: '5gexWit5RAObTqG9cOJJRw',
  },
  AXURE: {
    keys: {
      confluence: 'appsplus-axure-confluence',
      jira: 'appsplus-axure-jira',
    },
    marketplace: {
      confluence: 1225841,
      jira: 1225842,
    },
    title: 'Axure',
    domain: ['axshare.com'],
    color: '#A82AF6',
    docs: 'https://docs.axure.com/axure-cloud/reference/publishing-axure-rp-projects',
    placeholder: 'https://[...].axshare.com',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Axure file',
      'Click "Share" then "Publish"',
      'Copy the link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  AZURESTATICWEB: {
    keys: {
      confluence: 'appsplus-azure-static-web-confluence',
      jira: 'appsplus-azure-static-web-jira',
    },
    marketplace: {
      confluence: 1225843,
      jira: 1225844,
    },
    title: 'Azure Static Web',
    domain: ['azurestaticapps.net'],
    color: '#0078D4',
    homepage: 'https://portal.azure.com',
    placeholder: 'https://[...].azurestaticapps.net',
    embedURL: (x) => x.url,
    tutorial: [
      'Open the [Azure] portal',
      'Click a deployment in "Static Web Apps"',
      'Copy the domain URL and paste above',
    ],
    scribe: 'VYt3EuB6Soave2r614Mzog',
  },
  BITBUCKETSNIPPETS: {
    keys: {
      confluence: 'appsplus-bitbucket-snippets-confluence',
      jira: 'appsplus-bitbucket-snippets-jira',
    },
    marketplace: {
      confluence: 1226702,
      jira: 1226703,
    },
    title: 'Bitbucket Snippets',
    domain: ['bitbucket.org'],
    color: '#0052CC',
    docs: 'https://support.atlassian.com/bitbucket-cloud/docs/snippets-overview/',
    placeholder: 'https://bitbucket.org/[...]',
    embed: {
      file: null,
      padding: 16,
      fontSize: 12,
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
    tutorial: [
      'Open your Bitbucket Snippet',
      'Set visibility to "Public"',
      'Copy link from the browser bar',
    ],
    note: 'Only public snippets will work',
    scribe: null,
  },
  BOX: {
    keys: {
      confluence: 'appsplus-box-confluence',
      jira: 'appsplus-box-jira',
    },
    marketplace: {
      confluence: 1225845,
      jira: 1225846,
    },
    title: 'Box',
    domain: ['/box.com', '.box.com'],
    color: '#0061D5',
    docs: 'https://support.box.com/hc/en-us/articles/360043697094-Creating-Shared-Links',
    placeholder: 'https://app.box.com/s/[...]',
    embed: {
      view: 'list',
      sortColumn: 'date',
      sortDirection: 'ASC',
      showParentPath: false,
      showItemFeedActions: true,
    },
    embedURL: (x) =>
      !x.url?.includes('/embed')
        ? `${x.url.replace('.com', '.com/embed')}${Helpers.encodeParams(x)}`
        : x.url,
    // picker: 'Box',
    tutorial: [
      'Open your Box file, folder or document',
      'Click "Share", then "Create shared link"',
      'Then click "Copy"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CALENDLY: {
    keys: {
      confluence: 'appsplus-calendly-confluence',
      jira: 'appsplus-calendly-jira',
    },
    marketplace: {
      confluence: 1225847,
      jira: 1225848,
    },
    title: 'Calendly',
    domain: ['calendly.com'],
    color: '#006BFF',
    docs: 'https://help.calendly.com/hc/en-us/articles/1500000198241-How-to-locate-and-share-your-Calendly-link',
    placeholder: 'https://calendly.com/[...]',
    embed: {
      hide_event_type_details: null,
      hide_gdpr_banner: 1,
    },
    embedURL: (x) => `${x.url}${Helpers.encodeParams(x)}`,
    tutorial: ['Open your Calendly booking page', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CALENDSO: {
    keys: {
      confluence: 'appsplus-calendso-confluence',
      jira: 'appsplus-calendso-jira',
    },
    marketplace: {
      confluence: 1225849,
      jira: 1225850,
    },
    title: 'Cal.com',
    domain: ['/cal.com', 'calendso.com'],
    color: '#272727',
    docs: 'https://docs.cal.com',
    placeholder: 'https://cal.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your Cal.com booking page', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CANVA: {
    keys: {
      confluence: 'appsplus-canva-confluence',
      jira: 'appsplus-canva-jira',
    },
    marketplace: {
      confluence: 1225851,
      jira: 1225852,
    },
    title: 'Canva',
    domain: ['canva.com'],
    color: '#00C4CC',
    docs: 'https://www.canva.com/en_au/help/article/share-via-link-or-email',
    placeholder: 'https://www.canva.com/design/[...]',
    embed: {
      type: 'view',
    },
    embedURL: (x) =>
      `${x.url.substr(0, x.url.lastIndexOf('/'))}/${x.type}?embed`,
    tutorial: [
      'Open your Canva design',
      'Click "Share", select "Share a link to view"',
      'Click "Copy link"',
    ],
    note: 'Private links will not work',
    scribe: null,
  },
  CARDBOARD: {
    keys: {
      confluence: 'appsplus-cardboard-confluence',
      jira: 'appsplus-cardboard-jira',
    },
    marketplace: {
      confluence: 1226318,
      jira: 1226319,
    },
    title: 'CardBoard',
    domain: ['cardboardit.com'],
    color: '#0074AD',
    docs: 'https://cardboardit.com/help',
    placeholder: 'https://app.cardboardit.com/maps/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your CardBoard board',
      'Click three dots, then "Share Board"',
      'Click "Copy"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CAUSAL: {
    keys: {
      confluence: 'appsplus-causal-confluence',
      jira: 'appsplus-causal-jira',
    },
    marketplace: {
      confluence: 1228658,
      jira: 1228659,
    },
    title: 'Causal',
    domain: ['causal.app'],
    color: '#C3D9F3',
    docs: 'https://docs.causal.app/managing-models-and-collaboration/collaboration/sharing-models#embedding-your-model',
    placeholder: 'https://my.causal.app/models/[...]',
    embedURL: (x) =>
      !x.url?.includes('/embed')
        ? `${x.url.replace('/edit/', '/')}/embed`
        : x.url,
    tutorial: [
      'Open your Causal model',
      'Click "Share", enable "Share via link"',
      'Click "copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CHARTBLOCKS: {
    keys: {
      confluence: 'appsplus-chartblocks-confluence',
      jira: 'appsplus-chartblocks-jira',
    },
    marketplace: {
      confluence: 1226333,
      jira: 1226334,
    },
    title: 'ChartBlocks',
    domain: ['chartblocks.com'],
    color: '#2D3338',
    docs: 'https://www.chartblocks.com/en/support/faqs/faq/embedding-a-chart-on-your-website',
    placeholder: 'https://embed.chartblocks.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('embed')
        ? x.url
            .replace('?', '&')
            .replace(
              'public.chartblocks.com/c/',
              'embed.chartblocks.com/1.0/?c='
            )
        : x.url,
    tutorial: [
      'Open your chart',
      'Click "Share" icon',
      'Copy the "Public link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CHILIPIPER: {
    keys: {
      confluence: 'appsplus-chili-piper-confluence',
      jira: 'appsplus-chili-piper-jira',
    },
    marketplace: {
      confluence: 1225853,
      jira: 1225854,
    },
    title: 'Chili Piper',
    domain: ['chilipiper.com'],
    color: '#FF5722',
    docs: 'https://help.chilipiper.com/hc/en-us/articles/360056354434',
    placeholder: 'https://[...].chilipiper.com/book/me/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Chili Piper booking page',
      'Copy link from browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CLICKUP: {
    keys: {
      confluence: 'appsplus-clickup-confluence',
      jira: 'appsplus-clickup-jira',
    },
    marketplace: {
      confluence: 1225855,
      jira: 1225856,
    },
    title: 'ClickUp',
    domain: ['clickup.com'],
    requires: 'sharing.clickup.com',
    color: '#7B68EE',
    homepage: 'https://clickup.com',
    placeholder: 'https://sharing.clickup.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open [ClickUp] and click "Share"',
      'Select "Share this view" and create link',
      'Copy link and paste above',
    ],
    scribe: null,
  },
  CLOUDFLAREPAGES: {
    keys: {
      confluence: 'appsplus-cloudflare-pages-confluence',
      jira: 'appsplus-cloudflare-pages-jira',
    },
    marketplace: {
      confluence: 1225857,
      jira: 1225858,
    },
    title: 'Cloudflare Pages',
    domain: [],
    color: '#F38020',
    placeholder: 'https://[...].pages.dev',
    embed: {
      token: null,
      accountId: null,
      projectName: null,
      details: ['env', 'link', 'status'],
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
  },
  CODA: {
    keys: {
      confluence: 'appsplus-coda-confluence',
      jira: 'appsplus-coda-jira',
    },
    marketplace: {
      confluence: 1225861,
      jira: 1225862,
    },
    title: 'Coda',
    domain: ['coda.io'],
    color: '#F46A54',
    docs: 'https://help.coda.io/en/articles/1137949-sharing-your-doc',
    placeholder: 'https://coda.io/[...]',
    embedURL: (x) => {
      if (x.url?.includes('coda.io/embed')) return x.url
      const obj = x.url.replace(/#.*$/, '').split('/')
      let child = obj.pop().split('_').pop()
      if (child) child = `/_${child}`
      let parent = obj.pop().split(/_(.*)/s)[1]?.slice(1)
      if (parent) {
        parent = `/${parent}`
      } else {
        parent = ''
        child = `/${child?.slice(3)}`
      }
      return `https://coda.io/embed${parent}${child}`
    },
    tutorial: [
      'Open your Coda document, click "Share"',
      'Set "Anyone with the link" to "Can view"',
      'Click "Embed" tab and "Copy Embed"',
    ],
    note: 'Only public links will work',
    scribe: null,
  },
  CODEPEN: {
    keys: {
      confluence: 'appsplus-codepen-confluence',
      jira: 'appsplus-codepen-jira',
    },
    marketplace: {
      confluence: 1225863,
      jira: 1225864,
    },
    title: 'CodePen',
    domain: ['codepen.io'],
    color: '#000000',
    docs: 'https://blog.codepen.io/documentation/embedded-pens/',
    placeholder: 'https://codepen.io/[...]',
    embed: {
      defaultTab: 'html',
      darkMode: true,
      result: true,
      preload: true,
    },
    embedURL: (x) =>
      `${x.url.replace(
        /\/(pen|details|full)\//gi,
        x.preload ? '/embed/' : '/embed/preview/'
      )}?theme-id=${x.darkMode ? 'dark' : 'light'}&default-tab=${x.defaultTab}${
        x.result ? ',result' : ''
      }`,
    tutorial: [
      'Open your CodePen',
      'Copy link from the browser bar',
      'Configure options in sidebar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  CODESANDBOX: {
    keys: {
      confluence: 'appsplus-codesandbox-confluence',
      jira: 'appsplus-codesandbox-jira',
    },
    marketplace: {
      confluence: 1225865,
      jira: 1225866,
    },
    title: 'CodeSandbox',
    domain: ['codesandbox.io'],
    color: '#000000',
    docs: 'https://codesandbox.io/docs/embedding',
    placeholder: 'https://codesandbox.io/[...]',
    embed: {
      view: null,
      editor: true,
      preview: true,
      theme: 'dark',
      hidenavigation: 1,
      expanddevtools: null,
      moduleview: null,
      previewwindow: null,
      eslint: null,
      fontsize: 14,
      module: null,
    },
    embedURL: (x) => {
      x.url = x.url.replace(/\?.*$/, '')
      return `${x.url
        .replace('.io/s', '.io/embed')
        .replace(/\?.*$/, '')}${Helpers.encodeParams(x, false, [
        'url',
        'editor',
        'preview',
      ])}`
    },
    tutorial: [
      'Open your CodeSandbox',
      'Copy link from the browser bar',
      'Configure options in sidebar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  COLLABOARD: {
    keys: {
      confluence: 'appsplus-collaboard-confluence',
      jira: 'appsplus-collaboard-jira',
    },
    marketplace: {
      confluence: 1232901,
      jira: 1232900,
    },
    title: 'Collaboard',
    domain: ['collaboard.app'],
    color: '#C7D306',
    homepage: 'https://www.collaboard.app',
    placeholder: 'https://web.collaboard.app/[...]',
    embedURL: (x) => x.url.replace('/acceptProjectInvitation', '/embed'),
    tutorial: [
      'Open a [Collaboard] whiteboard',
      'Click top-right share icon',
      'Set permissions to view or edit',
      '"Generate embed code" and paste above',
    ],
    scribe: 'UznmQDO6TgOqr_c8FZdX5Q',
  },
  CONCEPTBOARD: {
    keys: {
      confluence: 'appsplus-conceptboard-confluence',
      jira: 'appsplus-conceptboard-jira',
    },
    marketplace: {
      confluence: 1226305,
      jira: 1226306,
    },
    title: 'Conceptboard',
    domain: ['conceptboard.com'],
    color: '#107FC9',
    docs: 'https://help.conceptboard.com/hc/en-us/articles/201775772-Sharing-Boards-Access-Management',
    placeholder: 'https://app.conceptboard.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your Conceptboard', 'Click "Share"', 'Click "Copy link"'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  DEEPNOTE: {
    keys: {
      confluence: 'appsplus-deepnote-confluence',
      jira: 'appsplus-deepnote-jira',
    },
    marketplace: {
      confluence: 1225867,
      jira: 1225868,
    },
    title: 'Deepnote',
    domain: ['embed.deepnote.com'],
    color: '#3793EF',
    docs: 'https://docs.deepnote.com/importing-and-exporing/share-or-embed-a-cell',
    placeholder: 'https://embed.deepnote.com/[...]',
    embed: {
      width: 100,
      height: 100,
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Select a Deepnote code or output block',
      'Click "Share block", enable toggle',
      'Copy link under "Share block"',
    ],
    note: 'Only code and output blocks will work',
    scribe: null,
  },
  DESCRIPT: {
    keys: {
      confluence: 'appsplus-descript-confluence',
      jira: 'appsplus-descript-jira',
    },
    marketplace: {
      confluence: 1228892,
      jira: 1228891,
    },
    title: 'Descript',
    domain: ['share.descript.com'],
    color: '#0062FF',
    docs: 'https://www.descript.com/tools/embed-video',
    placeholder: 'https://share.descript.com/[...]',
    embedURL: (x) => x.url.replace('.com/view', '.com/embed'),
    tutorial: [
      'Open your Descript project, click "Share"',
      'Click "Export" tab, select "Page"',
      'Publish and copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  DIGITALOCEAN: {
    keys: {
      confluence: 'appsplus-digitalocean-confluence',
      jira: 'appsplus-digitalocean-jira',
    },
    marketplace: {
      confluence: 1225871,
      jira: 1225872,
    },
    title: 'DigitalOcean',
    domain: ['ondigitalocean.app'],
    color: '#0080FF',
    homepage: 'https://www.digitalocean.com',
    placeholder: 'https://[...].ondigitalocean.app',
    embedURL: (x) => x.url,
    tutorial: [
      'Login to [DigitalOcean]',
      'Click "Apps" in sidebar',
      'Copy app URL and paste above',
    ],
    scribe: '97yacyNuT4-8HzuDzd4yFw',
  },
  DRAWIO: {
    keys: {
      confluence: 'appsplus-drawio-confluence',
      jira: 'appsplus-drawio-jira',
    },
    marketplace: {
      confluence: 1225869,
      jira: 1225870,
    },
    title: 'Diagrams.net',
    domain: ['diagrams.net', 'draw.io', 'diagrams.appsplus.co'],
    color: '#F08705',
    homepage: 'https://app.diagrams.net',
    placeholder: 'https://viewer.diagrams.net/[...]',
    attachments: ['.drawio'],
    embed: {
      attachmentId: null,
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Upload .drawio attachment or...',
      'Open a [Diagrams.net] diagram',
      'Set storage to Google Drive for updates',
      'Copy link from browser bar and paste above',
    ],
    scribe: null,
  },
  DROPBOX: {
    keys: {
      confluence: 'appsplus-dropbox-confluence',
      jira: 'appsplus-dropbox-jira',
    },
    marketplace: {
      confluence: 1225873,
      jira: 1225874,
    },
    title: 'Dropbox',
    domain: ['dropbox.com'],
    color: '#0061FF',
    docs: 'https://help.dropbox.com/files-folders/share/share-outside-dropbox',
    placeholder: 'https://www.dropbox.com/[...]',
    embed: {
      zoom: 'best',
      view: 'list',
      headerSize: 'normal',
    },
    embedURL: (x) => x.url,
    picker: 'Dropbox',
    tutorial: [
      'Select your Dropbox file, folder or document',
      'Click "Share" button, then "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  EVENTBRITE: {
    keys: {
      confluence: 'appsplus-eventbrite-confluence',
      jira: 'appsplus-eventbrite-jira',
    },
    marketplace: {
      confluence: 1225875,
      jira: 1225876,
    },
    title: 'Eventbrite',
    domain: ['eventbrite.com'],
    color: '#F05537',
    docs: 'https://www.eventbrite.com/support/articles/en_US/Multi_Group_How_To/how-to-sell-eventbrite-tickets-on-your-website-through-an-embedded-checkout',
    placeholder: 'https://eventbrite.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Eventbrite event page',
      'Copy link from the browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  EVERNOTE: {
    keys: {
      confluence: 'appsplus-evernote-confluence',
      jira: 'appsplus-evernote-jira',
    },
    marketplace: {
      confluence: 1225877,
      jira: 1225878,
    },
    title: 'Evernote',
    domain: ['evernote.com'],
    color: '#00A82D',
    docs: 'https://help.evernote.com/hc/en-us/articles/360053591694-Share-a-note-via-public-link',
    placeholder: 'https://www.evernote.com/[...]',
    embed: {
      link: false,
    },
    embedURL: (x) => `${x.url}?embed`,
    tutorial: [
      'Open your note and click "Share"',
      'Enable the shareable link toggle',
      'Copy the link',
    ],
    note: 'Embedded notes are read-only',
    scribe: null,
  },
  EXPOSNACK: {
    keys: {
      confluence: 'appsplus-expo-snack-confluence',
      jira: 'appsplus-expo-snack-jira',
    },
    marketplace: {
      confluence: 1225879,
      jira: 1225880,
    },
    title: 'Expo Snack',
    domain: ['snack.expo.dev'],
    color: '#000020',
    docs: 'https://docs.expo.dev/workflow/snack/',
    placeholder: 'https://snack.expo.dev/[...]',
    embed: {
      platform: 'web',
      preview: true,
      theme: 'light',
    },
    embedURL: (x) =>
      `${x.url.replace('.dev', '.dev/embedded')}${Helpers.encodeParams(x)}`,
    tutorial: ['Open an Expo Snack', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FACEBOOK: {
    keys: {
      confluence: 'appsplus-facebook-confluence',
      jira: 'appsplus-facebook-jira',
    },
    marketplace: {
      confluence: 1226704,
      jira: 1226705,
    },
    title: 'Facebook',
    domain: ['facebook.com'],
    color: '#1877F2',
    docs: 'https://www.facebook.com/help/',
    placeholder: 'https://facebook.com/[...]',
    embed: {
      features: ['showText', 'timeline', 'showCover'],
      height: 500,
      width: 1000,
      padding: 16,
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Open a Facebook page, group, post or video',
      'Copy link from the browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FELT: {
    keys: {
      confluence: 'appsplus-felt-confluence',
      jira: 'appsplus-felt-jira',
    },
    marketplace: {
      confluence: 1229816,
      jira: 1229815,
    },
    title: 'Felt Maps',
    domain: ['felt.com'],
    color: '#3D521E',
    docs: 'https://feltmaps.notion.site/Tips-for-Felting-b16e615a3498463b907ab3889aa3c03f',
    placeholder: 'https://felt.com/map/[...]',
    embedURL: (x) =>
      !x.url.includes('.com/embed')
        ? x.url.replace('.com', '.com/embed')
        : x.url,
    tutorial: [
      'Open your map, click "Share"',
      'Toggle on "Share to web"',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FIGMA: {
    keys: {
      confluence: 'appsplus-figma-confluence',
      jira: 'appsplus-figma-jira',
    },
    marketplace: {
      confluence: 1225723,
      jira: 1225609,
    },
    title: 'Figma & FigJam',
    domain: ['figma.com'],
    color: '#F24E1E',
    homepage: 'https://www.figma.com',
    placeholder: 'https://www.figma.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('/embed')
        ? `https://www.figma.com/embed?embed_host=share&url=${encodeURIComponent(
            x.url
          )}`
        : x.url,
    tutorial: [
      'Open a [Figma] or FigJam design',
      'Select items to frame then click "Share"',
      'Click "Copy link" and paste above',
    ],
    scribe: 'eEvDr-gMSVSVMOWIy8mfYw',
  },
  FIREBASE: {
    keys: {
      confluence: 'appsplus-firebase-confluence',
      jira: 'appsplus-firebase-jira',
    },
    marketplace: {
      confluence: 1225881,
      jira: 1225882,
    },
    title: 'Firebase',
    domain: ['web.app', 'firebaseapp.com'],
    color: '#FFCA28',
    docs: 'https://firebase.google.com/docs/hosting/',
    placeholder: 'https://[...].web.app',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your hosted Firebase website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  FLOWMAPP: {
    keys: {
      confluence: 'appsplus-flowmapp-confluence',
      jira: 'appsplus-flowmapp-jira',
    },
    marketplace: {
      confluence: 1226322,
      jira: 1226323,
    },
    title: 'FlowMapp',
    domain: ['flowmapp.com'],
    color: '#0D87FF',
    docs: 'https://help.flowmapp.com/help/share-project/',
    placeholder: 'https://app.flowmapp.com/share/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your FlowMapp project',
      'Click "Share" icon',
      'Toggle on, copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FLOWVELLA: {
    keys: {
      confluence: 'appsplus-flowvella-confluence',
      jira: 'appsplus-flowvella-jira',
    },
    marketplace: {
      confluence: 1225883,
      jira: 1225884,
    },
    title: 'FlowVella',
    domain: ['flowvella.com'],
    color: '#0070BC',
    docs: 'https://flowvella.com/support',
    placeholder: 'https://flowvella.com/[...]',
    embedURL: (x) => `${x.url}?iframe=true`,
    tutorial: ['Open your FlowVella project', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FORMSITE: {
    keys: {
      confluence: 'appsplus-formsite-confluence',
      jira: 'appsplus-formsite-jira',
    },
    marketplace: {
      confluence: 1225885,
      jira: 1225886,
    },
    title: 'Formsite',
    domain: ['formsite.com'],
    color: '#008EFF',
    docs: 'https://www.formsite.com/blog/embed-forms-site/',
    placeholder: 'https://[...].formsite.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Hover over your form', 'Click "Share"', 'Copy "Form Link"'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FORMSTACK: {
    keys: {
      confluence: 'appsplus-formstack-confluence',
      jira: 'appsplus-formstack-jira',
    },
    marketplace: {
      confluence: 1225887,
      jira: 1225888,
    },
    title: 'Formstack',
    domain: ['formstack.com'],
    color: '#21B573',
    docs: 'https://help.formstack.com/hc/en-us/articles/360019516071-Linking-and-Embedding',
    placeholder: 'https://[...].formstack.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your form', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  FRAMER: {
    keys: {
      confluence: 'appsplus-framer-confluence',
      jira: 'appsplus-framer-jira',
    },
    marketplace: {
      confluence: 1225889,
      jira: 1225890,
    },
    title: 'Framer',
    domain: ['framer.com', 'framer.app'],
    color: '#0055FF',
    docs: 'https://www.framer.com/learn/publishing-prototypes/',
    placeholder: 'https://[...].framer.app',
    embedURL: (x) => `${x.url.replace('.com/share', '.com/embed')}`,
    tutorial: [
      'Open your Framer project',
      'Click "Publish"',
      'Copy published link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GECKOBOARD: {
    keys: {
      confluence: 'appsplus-geckoboard-confluence',
      jira: 'appsplus-geckoboard-jira',
    },
    marketplace: {
      confluence: 1225891,
      jira: 1225892,
    },
    title: 'Geckoboard',
    domain: ['geckoboard.com'],
    color: '#0FD354',
    docs: 'https://support.geckoboard.com/hc/en-us/articles/202333706-Share-your-dashboard-with-share-links',
    placeholder: 'https://share.geckoboard.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Geckoboard, click "Share"',
      'Click "Create share link"',
      'Copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GIPHY: {
    keys: {
      confluence: 'appsplus-giphy-confluence',
      jira: 'appsplus-giphy-jira',
    },
    marketplace: {
      confluence: 1225893,
      jira: 1225894,
    },
    title: 'Giphy',
    domain: ['giphy.com'],
    color: '#FF6666',
    docs: 'https://support.giphy.com/hc/en-us/articles/360020330711-How-to-Embed-a-GIF',
    placeholder: 'https://giphy.com/gifs/[...]',
    embed: {
      background: '#000000',
    },
    embedURL: (x) => {
      const url = x.url.replace(/\?.*$/, '')
      if (url?.includes('giphy.gif'))
        return `https://giphy.com/embed/${url
          .replace('/giphy.gif', '')
          .split('/')
          .pop()}`
      if (!url?.includes('.com/embed/'))
        return `https://giphy.com/embed/${url
          .split('/')
          .pop()
          .split('-')
          .pop()}`
      return url
    },
    tutorial: [
      'Open your Giphy GIF',
      'Click "Share" and "Copy GIF Link"',
      'Or copy link from browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GITBOOK: {
    keys: {
      confluence: 'appsplus-gitbook-confluence',
      jira: 'appsplus-gitbook-jira',
    },
    marketplace: {
      confluence: 1225895,
      jira: 1225896,
    },
    title: 'GitBook',
    domain: ['gitbook.io', 'gitbook.com'],
    color: '#3884FF',
    docs: 'https://docs.gitbook.com/',
    placeholder: 'https://[...].gitbook.io',
    embedURL: (x) => x.url,
    tutorial: ['Open your GitBook', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GITHUBGIST: {
    keys: {
      confluence: 'appsplus-github-gist-confluence',
      jira: 'appsplus-github-gist-jira',
    },
    marketplace: {
      confluence: 1225897,
      jira: 1225898,
    },
    title: 'GitHub Gist',
    domain: ['gist.github.com'],
    color: '#181717',
    docs: 'https://docs.github.com/en/github/writing-on-github/editing-and-sharing-content-with-gists/creating-gists#creating-a-gist',
    placeholder: 'https://gist.github.com/[...]',
    embed: {
      file: null,
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
    tutorial: ['Open your GitHub Gist', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GITHUBPAGES: {
    keys: {
      confluence: 'appsplus-github-pages-confluence',
      jira: 'appsplus-github-pages-jira',
    },
    marketplace: {
      confluence: 1225899,
      jira: 1225900,
    },
    title: 'GitHub Pages',
    domain: ['github.io'],
    color: '#172B4D',
    docs: 'https://docs.github.com/en/pages',
    placeholder: 'https://[...].github.io',
    embedURL: (x) => x.url,
    tutorial: ['Open your published GitHub Page', 'Copy link from browser bar'],
    note: 'Only public GitHub Pages will work',
    scribe: null,
  },
  GITLABPAGES: {
    keys: {
      confluence: 'appsplus-gitlab-pages-confluence',
      jira: 'appsplus-gitlab-pages-jira',
    },
    marketplace: {
      confluence: 1225901,
      jira: 1225902,
    },
    title: 'GitLab Pages',
    domain: ['gitlab.io'],
    color: '#FCA121',
    docs: 'https://docs.gitlab.com/ee/user/project/pages/',
    placeholder: 'https://[...].gitlab.io',
    embedURL: (x) => x.url,
    tutorial: ['Open your published GitLab Page', 'Copy link from browser bar'],
    note: 'Only public GitLab Pages will work',
    scribe: null,
  },
  GITLABSNIPPETS: {
    keys: {
      confluence: 'appsplus-gitlab-snippets-confluence',
      jira: 'appsplus-gitlab-snippets-jira',
    },
    marketplace: {
      confluence: 1225903,
      jira: 1225904,
    },
    title: 'GitLab Snippets',
    domain: ['gitlab.com', '/gitlab/'],
    color: '#FC6D27',
    docs: 'https://docs.gitlab.com/ee/user/snippets.html',
    placeholder: 'https://gitlab.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your GitLab Snippet',
      'Set visibility to "Public"',
      'Copy link from the browser bar',
    ],
    note: 'Only public snippets will work',
    scribe: null,
  },
  GLIFFY: {
    keys: {
      confluence: 'appsplus-gliffy-confluence',
      jira: 'appsplus-gliffy-jira',
    },
    marketplace: {
      confluence: 1225905,
      jira: 1225906,
    },
    title: 'Gliffy',
    domain: ['gliffy.com'],
    color: '#1787FB',
    docs: 'https://help.gliffy.com/online/Content/GliffyOnline/Sharing-diagrams.htm',
    placeholder: 'https://go.gliffy.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your diagram', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLEANALYTICS: {
    keys: {
      confluence: 'appsplus-google-analytics-confluence',
      jira: 'appsplus-google-analytics-jira',
    },
    marketplace: {
      confluence: 1225907,
      jira: 1225908,
    },
    title: 'Google Analytics',
    domain: ['analytics.google.com', 'lookerstudio.google.com'],
    color: '#E37400',
    homepage: 'https://lookerstudio.google.com',
    placeholder: 'https://lookerstudio.google.com/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open [Looker Studio] and create GA4 template',
      'Select your Google Analytics property',
      'Click "Edit" then "File" and "Embed report"',
      'Enable embedding and copy the "Embed URL"',
    ],
    scribe: null,
  },
  GOOGLECALENDAR: {
    keys: {
      confluence: 'appsplus-google-calendar-confluence',
      jira: 'appsplus-google-calendar-jira',
    },
    marketplace: {
      confluence: 1225909,
      jira: 1225910,
    },
    title: 'Google Calendar',
    domain: ['calendar.google.com'],
    color: '#4285F4',
    homepage: 'https://calendar.google.com',
    placeholder: 'https://calendar.google.com/[...]',
    embed: {
      title: '',
      showNav: 1,
      showPrint: 1,
      showTitle: 1,
      showDate: 1,
      showTabs: 1,
      showCalendars: 1,
      showTz: 1,
      bgcolor: '#FFFFFF',
      mode: 'WEEK',
      wkst: 2,
      hl: 'en',
      ctz: null,
    },
    embedURL: (x) => {
      let url
      if (x.url?.includes('/settings'))
        url = `https://calendar.google.com/calendar/embed?src=${
          x.url.match(/settings\/calendar\/([^?]*)/)?.[1]
        }`
      if (x.url?.includes('cid='))
        url = `https://calendar.google.com/calendar/embed?src=${
          x.url.match(/cid=([^&]*)/)?.[1]
        }`
      if (x.url?.includes('basic.ics'))
        url = x.url
          .replace('/ical/', '/embed?src=')
          .replace('/public/basic.ics', '')
      // in case of multiple embeds: https://calendar.google.com/calendar/u/0/embedhelper
      if (x.url?.includes('/embed')) {
        const params = new URL(x.url).searchParams
        const newParams = new URLSearchParams()
        params.forEach((value, key) => {
          if (key === 'src' || key === 'color') newParams.append(key, value)
        })
        url = `https://calendar.google.com/calendar/embed?${newParams.toString()}`
      }
      return `${url}${Helpers.encodeParams(x, true, ['url', 'src', 'color'])}`
    },
    cookieSkip: true,
    tutorial: [
      'Open [Google Calendar] settings via top-right cog icon',
      'Select calendar in sidebar, then "Integrate calendar"',
      'Copy the "Embed code" and paste above',
      'Bonus: open "Customize" to add multiple calendars',
    ],
    scribe: 't71xgg59S4WqC-1elnDMOQ',
  },
  GOOGLEDATA: {
    keys: {
      confluence: 'appsplus-google-data-confluence',
      jira: 'appsplus-google-data-jira',
    },
    marketplace: {
      confluence: 1225911,
      jira: 1225913,
    },
    title: 'Looker Studio',
    domain: ['lookerstudio.google.com'],
    color: '#1A73E8',
    homepage: 'https://lookerstudio.google.com',
    placeholder: 'https://lookerstudio.google.com/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [Looker Studio] report and click "Edit"',
      'Select "File" then "Embed report"',
      'Enable embedding and copy the "Embed URL"',
    ],
    scribe: null,
  },
  GOOGLEDOCS: {
    keys: {
      confluence: 'appsplus-google-docs-confluence',
      jira: 'appsplus-google-docs-jira',
    },
    marketplace: {
      confluence: 1225914,
      jira: 1225915,
    },
    title: 'Google Docs',
    domain: ['docs.google.com/document'],
    color: '#4285F4',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://docs.google.com/document/[...]',
    embed: {
      preview: false,
      rm: 'minimal',
      link: false,
    },
    embedURL: (x) =>
      Helpers.appendQueryParams(
        x.preview ? x.url.replace('/edit', '/preview') : x.url,
        { rm: x.rm }
      ),
    picker: 'Google',
    tutorial: [
      'Open your Google Doc and click "Share"',
      'Set to "Anyone with the link" for best viewing',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLEDRAWINGS: {
    keys: {
      confluence: 'appsplus-google-drawings-confluence',
      jira: 'appsplus-google-drawings-jira',
    },
    marketplace: {
      confluence: 1225916,
      jira: 1225917,
    },
    title: 'Google Drawings',
    domain: ['docs.google.com/drawings'],
    color: '#DE5246',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://docs.google.com/drawings/[...]',
    embed: {
      preview: true,
      rm: 'minimal',
      link: true,
    },
    embedURL: (x) =>
      Helpers.appendQueryParams(
        x.preview ? x.url.replace('/edit', '/preview') : x.url,
        { rm: x.rm }
      ),
    picker: 'Google',
    tutorial: [
      'Open your Google Drawing and click "Share"',
      'Set to "Anyone with the link" for best viewing',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLEDRIVE: {
    keys: {
      confluence: 'appsplus-google-drive-confluence',
      jira: 'appsplus-google-drive-jira',
    },
    marketplace: {
      confluence: 1225918,
      jira: 1225919,
    },
    title: 'Google Drive',
    domain: ['drive.google.com'],
    color: '#4285F4',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://drive.google.com/file/[...]',
    embed: {
      grid: true,
      link: false,
    },
    embedURL: (x) => {
      const gId = x.url.match(/[-\w]{25,}/)
      return x.url?.includes('.com/drive/folders')
        ? `https://drive.google.com/embeddedfolderview?id=${gId}#${
            x.grid ? 'grid' : 'list'
          }`
        : `https://docs.google.com/viewer?srcid=${gId}&pid=explorer&efh=false&a=v&chrome=false&embedded=true`
    },
    picker: 'Google',
    tutorial: [
      'Open your doc or file and click "Share"',
      'Set to "Anyone with the link" for best viewing',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLEFORMS: {
    keys: {
      confluence: 'appsplus-google-forms-confluence',
      jira: 'appsplus-google-forms-jira',
    },
    marketplace: {
      confluence: 1225920,
      jira: 1225921,
    },
    title: 'Google Forms',
    domain: ['docs.google.com/forms', 'forms.gle'],
    color: '#703AB5',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://docs.google.com/forms/[...]',
    embedURL: (x) => `${x.url.replace('/edit', '/viewform?embedded=true')}`,
    picker: 'Google',
    tutorial: ['Open your Google Form', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLEMAPS: {
    keys: {
      confluence: 'appsplus-google-maps-confluence',
      jira: 'appsplus-google-maps-jira',
    },
    marketplace: {
      confluence: 1225922,
      jira: 1225923,
    },
    title: 'Google Maps',
    color: '#4285F4',
    embed: {
      type: 'view',
      maptype: 'roadmap',
      q: '',
      origin: '',
      destination: '',
      waypoints: [],
      mode: 'driving',
      manualPos: true,
      zoom: 12,
      center: {
        lat: -33.883251942988394,
        lng: 151.20443219405857,
      },
      heading: 180,
      pitch: 0,
      fov: 90,
      markers: [],
      markerDir: true,
      geoField: null,
      cluster: false,
      jql: '',
      mql: '',
    },
    cookieSkip: true,
  },
  GOOGLESHEETS: {
    keys: {
      confluence: 'appsplus-google-sheets-confluence',
      jira: 'appsplus-google-sheets-jira',
    },
    marketplace: {
      confluence: 1225925,
      jira: 1225926,
    },
    title: 'Google Sheets',
    domain: ['docs.google.com/spreadsheets'],
    color: '#34A853',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://docs.google.com/spreadsheets/[...]',
    embed: {
      preview: false,
      tabs: true,
      rm: 'minimal',
      link: false,
    },
    embedURL: (x) => {
      let url = x.url
      if (x.preview && !x.tabs) {
        url = x.url.replace('/edit', '/htmlembed')
        const baseUrl = new URL(url)
        const params = new URLSearchParams(baseUrl.hash.substring(1))
        return Helpers.appendQueryParams(baseUrl.origin + baseUrl.pathname, {
          gid: params.get('gid'),
          single: true,
          widget: false,
          chrome: false,
          headers: false,
        })
      }
      if (x.preview) url = x.url.replace('/edit', '/preview')
      return Helpers.appendQueryParams(url, { rm: x.rm })
    },
    picker: 'Google',
    tutorial: [
      'Open your Google Sheet and click "Share"',
      'Set to "Anyone with the link" for best viewing',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GOOGLESLIDES: {
    keys: {
      confluence: 'appsplus-google-slides-confluence',
      jira: 'appsplus-google-slides-jira',
    },
    marketplace: {
      confluence: 1225927,
      jira: 1225928,
    },
    title: 'Google Slides',
    domain: ['docs.google.com/presentation'],
    color: '#F8C002',
    docs: 'https://support.google.com/a/users/answer/9308873?hl=en',
    placeholder: 'https://docs.google.com/presentation/[...]',
    embed: {
      preview: true,
      rm: 'minimal',
      link: false,
    },
    embedURL: (x) =>
      Helpers.appendQueryParams(
        x.preview ? x.url.replace('/edit', '/preview') : x.url,
        { rm: x.rm }
      ),
    picker: 'Google',
    tutorial: [
      'Open your Google Slide and click "Share"',
      'Set to "Anyone with the link" for best viewing',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  GRAPHQL: {
    keys: {
      confluence: 'appsplus-graphql-playground-confluence',
      jira: 'appsplus-graphql-playground-jira',
    },
    marketplace: {
      confluence: 1225929,
      jira: 1225930,
    },
    title: 'GraphQL',
    color: '#E434AA',
    embed: {
      graphql:
        '[{"endpoint":"https://api.atlassian.com/graphql","query":"query Vendor {\\n  marketplacePartner(id: 1217269) {\\n    name\\n    contactDetails {\\n      emailId\\n    }\\n  }\\n}\\n","variables":"","headers":""}]',
    },
    cookieSkip: true,
  },
  HEROKU: {
    keys: {
      confluence: 'appsplus-heroku-confluence',
      jira: 'appsplus-heroku-jira',
    },
    marketplace: {
      confluence: 1225931,
      jira: 1225932,
    },
    title: 'Heroku',
    domain: ['herokuapp.com'],
    color: '#430098',
    docs: 'https://devcenter.heroku.com/',
    placeholder: 'https://[...].herokuapp.com',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your hosted Heroku website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  HOTJAR: {
    keys: {
      confluence: 'appsplus-hotjar-confluence',
      jira: 'appsplus-hotjar-jira',
    },
    marketplace: {
      confluence: 1225933,
      jira: 1225934,
    },
    title: 'Hotjar',
    domain: ['insights.hotjar.com'],
    color: '#FD3A5C',
    docs: 'https://help.hotjar.com/hc/en-us/articles/115011820608-Sharing-Recordings',
    placeholder: 'https://insights.hotjar.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your recording or heatmap', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  INSTAGRAM: {
    keys: {
      confluence: 'appsplus-instagram-confluence',
      jira: 'appsplus-instagram-jira',
    },
    marketplace: {
      confluence: 1225935,
      jira: 1225936,
    },
    title: 'Instagram',
    domain: ['instagram.com'],
    requires: '.com/p/',
    color: '#E4405F',
    docs: 'https://help.instagram.com/265701793533048',
    placeholder: 'https://instagram.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open an Instagram image', 'Copy link from the browser bar'],
    note: 'Profile pages will not work yet',
    scribe: null,
  },
  INVISION: {
    keys: {
      confluence: 'appsplus-invision-confluence',
      jira: 'appsplus-invision-jira',
    },
    marketplace: {
      confluence: 1225937,
      jira: 1225938,
    },
    title: 'InVision',
    domain: ['invisionapp.com', 'invis.io'],
    color: '#FF3366',
    docs: 'https://support.invisionapp.com/hc/en-us/articles/115005759126-How-do-I-share-my-InVision-prototype-board-or-freehand-',
    placeholder: 'https://projects.invisionapp.com/share/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your InVision prototype',
      'Choose a screen and click "Share"',
      'Copy the "private URL" link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  JOTFORM: {
    keys: {
      confluence: 'appsplus-jotform-confluence',
      jira: 'appsplus-jotform-jira',
    },
    marketplace: {
      confluence: 1225939,
      jira: 1225940,
    },
    title: 'JotForm',
    domain: ['jotform.com'],
    color: '#FF6100',
    docs: 'https://www.jotform.com/help/34-embedding-a-form-to-a-web-page',
    placeholder: 'https://jotform.com/[...]',
    embedURL: (x) => {
      const url = x.url.replace('/jsform', '')
      return url.includes('.com/tables') ? `${url}?embedMode=js` : url
    },
    tutorial: [
      'Open your published form or table',
      'Copy link from browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  JSFIDDLE: {
    keys: {
      confluence: 'appsplus-jsfiddle-confluence',
      jira: 'appsplus-jsfiddle-jira',
    },
    marketplace: {
      confluence: 1225941,
      jira: 1225942,
    },
    title: 'JSFiddle',
    domain: ['jsfiddle.net'],
    color: '#0084FF',
    docs: 'https://docs.jsfiddle.net/embedding-fiddles',
    placeholder: 'https://jsfiddle.net/[...]',
    embed: {
      features: ['js', 'html', 'css', 'result'],
      darkMode: false,
      fontColor: '#181919',
      accentColor: '#2E71FF',
      bodyColor: '#F3F5F6',
      menuColor: '#FFFFFF',
    },
    embedURL: (x) =>
      `${x.url}/embedded/${x.features?.join(',')}/${
        x.darkMode ? 'dark' : 'light'
      }/${Helpers.encodeParams(x, false, [
        'url',
        'features',
        'darkMode',
      ]).replace(/%23/g, '')}`,
    tutorial: [
      'Open your JSFiddle',
      'Copy link from the browser bar',
      'Configure options in sidebar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  JUSTINMIND: {
    keys: {
      confluence: 'appsplus-justinmind-confluence',
      jira: 'appsplus-justinmind-jira',
    },
    marketplace: {
      confluence: 1226311,
      jira: 1226310,
    },
    title: 'Justinmind',
    domain: ['justinmind.com'],
    color: '#40D2D2',
    docs: 'https://www.justinmind.com/support/collaboration-with-reviewers/',
    placeholder: 'https://cloud.justinmind.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('cloud.') ? x.url.replace('www.', 'cloud.') : x.url,
    tutorial: [
      'Publish your project',
      'Toggle on "Public prototype"',
      'Click "Get link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  JSON: {
    keys: {
      confluence: 'appsplus-json-viewer-confluence',
      jira: 'appsplus-json-viewer-jira',
    },
    marketplace: {
      confluence: 1229752,
      jira: 1229751,
    },
    title: 'JSON Viewer',
    domain: ['.json'],
    color: '#000000',
    attachments: ['.json'],
    embed: {
      attachmentId: null,
      theme: 'harmonic',
      clipboard: false,
      types: false,
      size: false,
      collapsed: false,
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
  },
  KOTLIN: {
    keys: {
      confluence: 'appsplus-kotlin-playground-confluence',
      jira: 'appsplus-kotlin-playground-jira',
    },
    marketplace: {
      confluence: 1226331,
      jira: 1226332,
    },
    title: 'Kotlin Playground',
    domain: ['kotl.in'],
    color: '#9E37F3',
    docs: 'https://play.kotlinlang.org',
    placeholder: 'https://pl.kotl.in/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open play.kotlinlang.org', 'Click "Share" icon', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  KINOPIO: {
    keys: {
      confluence: 'appsplus-kinopio-confluence',
      jira: 'appsplus-kinopio-jira',
    },
    marketplace: {
      confluence: 1229817,
      jira: 1229818,
    },
    title: 'Kinopio',
    domain: ['kinopio.club'],
    color: '#9BB3EF',
    docs: 'https://help.kinopio.club/posts/sharing-spaces/',
    placeholder: 'https://kinopio.club/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your space, click "Share"',
      'Click "Embed", then "URL"',
      'Copy URL',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  LINKEDIN: {
    keys: {
      confluence: 'appsplus-linkedin-confluence',
      jira: 'appsplus-linkedin-jira',
    },
    marketplace: {
      confluence: 1225943,
      jira: 1225944,
    },
    title: 'LinkedIn',
    domain: ['linkedin.com'],
    requires: '/embed/',
    color: '#0A66C2',
    homepage: 'https://www.linkedin.com',
    placeholder: 'https://www.linkedin.com/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Click triple dots on a [LinkedIn] post',
      'Select "Embed this post"',
      'Copy embed code and paste above',
    ],
    scribe: null,
  },
  LIVESTORM: {
    keys: {
      confluence: 'appsplus-livestorm-confluence',
      jira: 'appsplus-livestorm-jira',
    },
    marketplace: {
      confluence: 1225945,
      jira: 1225946,
    },
    title: 'Livestorm',
    domain: ['livestorm.co'],
    color: '#0B42C3',
    docs: 'https://support.livestorm.co/article/29-landing-page-to-register-people-to-a-webinar',
    placeholder: 'https://app.livestorm.co/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your event settings',
      'Click "Share event"',
      'Copy registration page link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  LOOM: {
    keys: {
      confluence: 'appsplus-loom-confluence',
      jira: 'appsplus-loom-jira',
    },
    marketplace: {
      confluence: 1225947,
      jira: 1225948,
    },
    title: 'Loom',
    domain: ['loom.com'],
    color: '#625DF5',
    docs: 'https://support.loom.com/hc/en-us/articles/360002208157-How-to-share-your-recording',
    placeholder: 'https://www.loom.com/share/[...]',
    embed: {
      hide_owner: true,
      hide_speed: true,
      hide_share: true,
      hide_title: false,
      hideEmbedTopBar: false,
      autoplay: 0,
      t: 0,
    },
    embedURL: (x) =>
      `${x.url.replace('.com/share', '.com/embed')}${Helpers.encodeParams(x)}`,
    tutorial: [
      'Open your Loom recording, click "Share"',
      'Set privacy to "Anyone with the link"',
      'Click "Copy link"',
    ],
    note: 'Only public links will work',
    scribe: null,
  },
  LOTTIEFILES: {
    keys: {
      confluence: 'appsplus-lottiefiles-confluence',
      jira: 'appsplus-lottiefiles-jira',
    },
    marketplace: {
      confluence: 1226315,
      jira: 1226314,
    },
    title: 'LottieFiles',
    domain: ['lottiefiles.com'],
    color: '#18C8CA',
    docs: 'https://lottiefiles.com',
    placeholder: 'https://lottiefiles.com/[...].json',
    embed: {
      features: ['autoplay', 'loop'],
      bounce: false,
      background: '#FFFFFF',
      speed: 1,
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Open a hosted LottieFiles animation',
      'Login and copy "Lottie Animation URL"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  LUCID: {
    keys: {
      confluence: 'appsplus-lucid-confluence',
      jira: 'appsplus-lucid-jira',
    },
    marketplace: {
      confluence: 1225949,
      jira: 1225950,
    },
    title: 'Lucidchart & Lucidspark',
    domain: ['lucid.app', 'lucidapp.'],
    color: '#FF3D3D',
    docs: 'https://lucidchart.zendesk.com/hc/en-us/articles/207300196-Publish-Your-Document',
    placeholder: 'https://lucid.app/[...]',
    embedURL: (x) =>
      !x.url?.includes('/embeddedchart/')
        ? `https://${new URL(x.url).hostname}/documents/embeddedchart/${
            x.url.match(
              /[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}/,
              'g'
            )?.[0]
          }`
        : x.url,
    tutorial: [
      'Open your Lucidchart or Lucidspark document',
      'Click "Share", then Link tab',
      'Enable "Shareable link", click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  LUDUS: {
    keys: {
      confluence: 'appsplus-ludus-confluence',
      jira: 'appsplus-ludus-jira',
    },
    marketplace: {
      confluence: 1225951,
      jira: 1225952,
    },
    title: 'Ludus',
    domain: ['app.ludus.one'],
    color: '#333342',
    docs: 'https://help.ludus.one/how-can-i-save-and-share-my-presentation',
    placeholder: 'https://app.ludus.one/[...]',
    embedURL: (x) => x.url.replace('/edit', ''),
    tutorial: [
      'Open your Ludus presentation',
      'Click "Share" icon',
      'Copy "public URL"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MARVEL: {
    keys: {
      confluence: 'appsplus-marvel-confluence',
      jira: 'appsplus-marvel-jira',
    },
    marketplace: {
      confluence: 1225953,
      jira: 1225954,
    },
    title: 'Marvel',
    domain: ['marvelapp.com'],
    color: '#1FB6FF',
    docs: 'https://help.marvelapp.com/hc/en-us/articles/360003582958-How-to-share-your-prototype-by-SMS-email-or-via-link',
    placeholder: 'https://marvelapp.com/prototype/[...]',
    embed: {
      frameless: false,
    },
    embedURL: (x) =>
      `${x.url}${Helpers.encodeParams({
        ...x,
        emb: 1,
      })}`,
    tutorial: ['Open your Marvel prototype', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MATOMO: {
    keys: {
      confluence: 'appsplus-matomo-confluence',
      jira: 'appsplus-matomo-jira',
    },
    marketplace: {
      confluence: 1225957,
      jira: 1225958,
    },
    title: 'Matomo',
    domain: ['matomo.cloud'],
    color: '#3152A0',
    homepage: 'https://matomo.org',
    placeholder: 'https://[...].matomo.cloud/[...]',
    embed: {
      token: null,
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Open [Matomo] and login',
      '[https://matomo.org/faq/reports/requirements-for-embedding-matomo-reports/|Setup] anonymous view or auth token',
      'Click "Settings" cog, "Export" then "Widgets"',
      'Select a report, copy "Direct Link" and paste above',
    ],
    scribe: null,
  },
  METABASE: {
    keys: {
      confluence: 'appsplus-metabase-confluence',
      jira: 'appsplus-metabase-jira',
    },
    marketplace: {
      confluence: 1225955,
      jira: 1225956,
    },
    title: 'Metabase',
    domain: ['metabase', '/public/dashboard/'],
    color: '#509EE3',
    homepage: 'https://metabase.com',
    placeholder: 'https://[...].metabase.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [Metabase] dashboard',
      'Enable and generate an embedding URL',
      'Copy link and paste above',
    ],
    scribe: null,
  },
  MSCALENDAR: {
    keys: {
      confluence: 'appsplus-microsoft-calendar-confluence',
      jira: 'appsplus-microsoft-calendar-jira',
    },
    marketplace: {
      confluence: 1225959,
      jira: 1225960,
    },
    title: 'Outlook Calendar',
    domain: ['/owa/calendar'],
    requires: '.html',
    color: '#0078D4',
    homepage: 'https://www.miro.com',
    placeholder: 'https://outlook.live.com/owa/calendar/[...]',
    embedURL: (x) =>
      x.url
        .replace('office365.com', 'office.com')
        .replace('.com/owa/calendar', '.com/calendar/published')
        .replace('/index.html', '/calendar.html'),
    tutorial: [
      'Open an [Outlook Calendar] on the web',
      'Click top-right settings icon then "Shared calendars"',
      '"Publish a calendar" and copy-paste the HTML link above',
    ],
    scribe: 'z3aRXdbORlu42eXYxbFoUw',
  },
  MSDESIGNER: {
    keys: {
      confluence: 'appsplus-microsoft-designer-confluence',
      jira: 'appsplus-microsoft-designer-jira',
    },
    marketplace: {
      confluence: 1230278,
      jira: 1230277,
    },
    title: 'Microsoft Designer',
    domain: ['designer.microsoft.com'],
    color: '#8627C2',
    docs: 'https://support.microsoft.com',
    placeholder: 'https://designer.microsoft.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your design', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MSEXCEL: {
    keys: {
      confluence: 'appsplus-microsoft-excel-confluence',
      jira: 'appsplus-microsoft-excel-jira',
    },
    marketplace: {
      confluence: 1225961,
      jira: 1225962,
    },
    title: 'Microsoft Excel',
    parent: 'MSONEDRIVE',
    color: '#217346',
    docs: 'https://support.microsoft.com/en-us/office/share-your-excel-workbook-with-others-8d8a52bb-03c3-4933-ab6c-330aabf1e589',
    placeholder: 'https://onedrive.live.com/embed?[...]',
    embed: {
      wdDownloadButton: null,
      wdHideGridlines: null,
      wdHideHeaders: null,
      wdAllowInteractivity: null,
      ActiveCell: null,
      link: false,
      footer: true,
    },
    embedURL: (x) => apps.MSONEDRIVE.embedURL(x),
    cookieSkip: true,
    attachments: ['.xls', '.xlsx'],
    picker: 'Onedrive',
    tutorial: [
      'Open your Excel Online document',
      'Click "File", "Share" then "Embed"',
      'Configure then copy the "Embed code"',
    ],
    note: 'Share links will also work (mostly)',
    scribe: null,
  },
  MSFORMS: {
    keys: {
      confluence: 'appsplus-microsoft-forms-confluence',
      jira: 'appsplus-microsoft-forms-jira',
    },
    marketplace: {
      confluence: 1225963,
      jira: 1225964,
    },
    title: 'Microsoft Forms',
    domain: ['forms.office.com'],
    color: '#03797C',
    docs: 'https://support.microsoft.com/en-us/office/share-a-form-384371be-f1e7-4628-bcba-abd3d6123917',
    placeholder: 'https://forms.office.com/[...]',
    embedURL: (x) => `${x.url}${Helpers.encodeParams({ ...x, embed: true })}`,
    tutorial: ['Open your form', 'Click "Collect responses"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MSONEDRIVE: {
    keys: {
      confluence: 'appsplus-microsoft-onedrive-confluence',
      jira: 'appsplus-microsoft-onedrive-jira',
    },
    marketplace: {
      confluence: 1225965,
      jira: 1225966,
    },
    title: 'OneDrive & SharePoint',
    domain: [
      '1drv.ms',
      'onedrive.live.com',
      'storage.live.com',
      'sharepoint.com',
    ],
    color: '#0078D4',
    docs: 'https://support.microsoft.com/en-us/office/embed-files-directly-into-your-website-or-blog-ed07dd52-8bdb-431d-96a5-cbe8a80b7418',
    placeholder: 'https://[...].sharepoint.com/[...]',
    embed: {
      link: false,
    },
    embedURL: (x) => {
      // Microsoft Stream
      if (x.url?.includes('/embed.aspx'))
        return x.url.endsWith('&embed=%7B')
          ? x.url.replace('&embed=%7B', '')
          : x.url

      try {
        Sentry.addBreadcrumb({
          message: 'onedriveURL',
          data: { url: x.url },
        })

        const url = new URL(x.url)

        const sourcedoc = new URLSearchParams(url.search).get('sourcedoc')
        if (sourcedoc) {
          return `${url.origin}${url.pathname.replace(
            'doc2.aspx',
            'Doc.aspx'
          )}?sourcedoc=${sourcedoc}&action=embedview`
        }

        if (url.origin?.includes('sharepoint.com')) {
          if (url.pathname.includes('/p/')) {
            return `${url.origin}${url.pathname}?action=embedview`
          }

          const paths = url.pathname.split('/')

          const dsourcedoc = new URLSearchParams(url.search).get('d')
          if (dsourcedoc) {
            return `${url.origin}${`/sites/${
              url.pathname.match(/\/sites\/([^/]+)/)?.[1]
            }`}/_layouts/15/Doc.aspx?sourcedoc={${dsourcedoc
              .slice(1)
              .replace(
                /(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/,
                '$1-$2-$3-$4-$5'
              )}}&action=embedview`
          }

          const share = paths.pop()
          return `${url.origin}${
            paths.length === 4 ? `/sites/${paths.pop()}` : ''
          }/_layouts/15/Doc.aspx?share=${share}&action=embedview`
        }
      } catch (e) {
        return x.url
      }
      return x.url
    },
    picker: 'Onedrive',
    tutorial: [
      'Open your file, folder or document',
      'Click "Embed" or "File">>"Share">>"Embed"',
      'Configure then copy the "Embed code"',
    ],
    note: 'Share links will also work (mostly)',
    scribe: null,
  },
  MSPOWERBI: {
    keys: {
      confluence: 'appsplus-microsoft-powerbi-confluence',
      jira: 'appsplus-microsoft-powerbi-jira',
    },
    marketplace: {
      confluence: 1225967,
      jira: 1225968,
    },
    title: 'Microsoft Power BI',
    domain: ['powerbi.com'],
    color: '#F2C811',
    docs: 'https://docs.microsoft.com/en-us/power-bi/collaborate-share/service-publish-to-web',
    placeholder: 'https://app.powerbi.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Power BI report',
      'Click "File" then "Embed report"',
      'Select "Website or portal" or "Publish to web"',
      'Copy embed code',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MSPOWERPOINT: {
    keys: {
      confluence: 'appsplus-microsoft-powerpoint-confluence',
      jira: 'appsplus-microsoft-powerpoint-jira',
    },
    marketplace: {
      confluence: 1225969,
      jira: 1225970,
    },
    title: 'Microsoft PowerPoint',
    parent: 'MSONEDRIVE',
    color: '#B7472A',
    docs: 'https://support.microsoft.com/en-us/office/share-your-powerpoint-presentation-with-others-a6308d9d-a0a8-443b-8e1c-0f4983f0afd1',
    placeholder: 'https://onedrive.live.com/embed?[...]',
    embed: {
      slide: 1,
      link: false,
    },
    embedURL: (x) => apps.MSONEDRIVE.embedURL(x),
    cookieSkip: true,
    attachments: ['.ppt', '.pptx'],
    picker: 'Onedrive',
    tutorial: [
      'Open your PowerPoint document',
      'Click "File", "Share" then "Embed"',
      'Configure then copy the "Embed code"',
    ],
    note: 'Share links will also work (mostly)',
    scribe: null,
  },
  MSSTREAM: {
    keys: {
      confluence: 'appsplus-microsoft-stream-confluence',
      jira: 'appsplus-microsoft-stream-jira',
    },
    marketplace: {
      confluence: 1225971,
      jira: 1225972,
    },
    title: 'Microsoft Stream',
    domain: ['microsoftstream.com', '/embed.aspx'],
    color: '#BC1948',
    docs: 'https://docs.microsoft.com/en-us/stream/portal-share-video',
    placeholder: 'https://web.microsoftstream.com/video/[...]',
    embed: {
      autoplay: false,
      showinfo: true,
      st: 0,
    },
    embedURL: (x) => {
      if (x.url?.includes('/embed.aspx'))
        return x.url.endsWith('&embed=%7B')
          ? x.url.replace('&embed=%7B', '')
          : x.url
      if (x.url?.includes('/stream.aspx')) {
        return x.url.replace('/stream.aspx', '/embed.aspx')
      }
      return `${
        !x.url?.includes('/embed')
          ? x.url.replace('.com/video', '.com/embed/video')
          : x.url
      }${Helpers.encodeParams(x, true)}`
    },
    tutorial: [
      'Classic: open your video',
      'SharePoint: "Share" then "Embed code"',
      'Copy browser bar link or embed code',
    ],
    scribe: null,
  },
  MSSWAY: {
    keys: {
      confluence: 'appsplus-microsoft-sway-confluence',
      jira: 'appsplus-microsoft-sway-jira',
    },
    marketplace: {
      confluence: 1225973,
      jira: 1225974,
    },
    title: 'Microsoft Sway',
    domain: ['sway.office.com'],
    color: '#1A6B5F',
    docs: 'https://support.microsoft.com/en-us/office/share-your-sway-1cf853b8-ef7e-46b0-b704-003e58d28998',
    placeholder: 'https://sway.office.com/[...]',
    embedURL: (x) =>
      `${
        !x.url?.includes('/embed')
          ? `${x.url.replace('.com', '.com/s').replace(/\?.*$/, '')}/embed`
          : x.url
      }`,
    tutorial: ['Open your Sway', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MSVISIO: {
    keys: {
      confluence: 'appsplus-microsoft-visio-confluence',
      jira: 'appsplus-microsoft-visio-jira',
    },
    marketplace: {
      confluence: 1225975,
      jira: 1225976,
    },
    title: 'Microsoft Visio',
    parent: 'MSONEDRIVE',
    color: '#3955A3',
    docs: 'https://support.microsoft.com/en-us/office/display-a-visio-diagram-on-a-web-page-cecad64e-e0c4-49d0-93e0-acdd3709c57c',
    placeholder: 'https://onedrive.live.com/embed?[...]',
    embed: {
      link: false,
    },
    embedURL: (x) => apps.MSONEDRIVE.embedURL(x),
    attachments: ['.vsdx'],
    picker: 'Onedrive',
    tutorial: [
      'Open your Visio Online document',
      'Click "File", "Share" then "Embed"',
      'Configure then copy the "Embed code"',
    ],
    note: 'Share links will also work (mostly)',
    scribe: null,
  },
  MSWORD: {
    keys: {
      confluence: 'appsplus-microsoft-word-confluence',
      jira: 'appsplus-microsoft-word-jira',
    },
    marketplace: {
      confluence: 1225977,
      jira: 1225978,
    },
    title: 'Microsoft Word',
    parent: 'MSONEDRIVE',
    color: '#2B579A',
    docs: 'https://support.microsoft.com/en-us/office/share-a-document-d39f3cd8-0aa0-412f-9a35-1abba926d354?ui=en-us&rs=en-us&ad=us',
    placeholder: 'https://onedrive.live.com/embed?[...]',
    embed: {
      link: false,
    },
    embedURL: (x) => apps.MSONEDRIVE.embedURL(x),
    attachments: ['.doc', '.docx'],
    picker: 'Onedrive',
    tutorial: [
      'Open your Word Online document',
      'Click "File", "Share" then "Embed"',
      'Configure then copy the "Embed code"',
    ],
    note: 'Share links will also work (mostly)',
    scribe: null,
  },
  MINDMEISTER: {
    keys: {
      confluence: 'appsplus-mindmeister-confluence',
      jira: 'appsplus-mindmeister-jira',
    },
    marketplace: {
      confluence: 1226312,
      jira: 1226313,
    },
    title: 'MindMeister',
    domain: ['mm.tt', 'mindmeister.com'],
    color: '#F7578C',
    homepage: 'https://www.mindmeister.com',
    placeholder: 'https://mindmeister.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('.com/maps')
        ? x.url
            .replace('mm.tt', 'mindmeister.com')
            .replace(/\/[a-z]{2}\/map/, '')
            .replace('.com', '.com/maps/public_map_shell')
        : x.url,
    tutorial: [
      'Open your [MindMeister] mind map',
      'Click top-left logo then "Publish"',
      'First copy the public link then publish',
    ],
    scribe: null,
  },
  MIRO: {
    keys: {
      confluence: 'appsplus-miro-confluence',
      jira: 'appsplus-miro-jira',
    },
    marketplace: {
      confluence: 1225980,
      jira: 1225981,
    },
    title: 'Miro',
    domain: ['miro.com'],
    color: '#FFD02F',
    homepage: 'https://www.miro.com',
    placeholder: 'https://miro.com/app/board/[...]',
    embed: {
      pres: 0,
      frameId: 1,
      moveToViewport: null,
    },
    embedURL: (x) => {
      const url = x.url.replace(/\?.*$/, '').replace('/board', '/live-embed')
      return `${url}${Helpers.encodeParams({ ...x, url })}`
    },
    cookieSkip: true,
    tutorial: [
      'Open a [Miro] board',
      'Click "Share" then "Get embed code"',
      'Copy the code and paste above',
    ],
    scribe: 'w0e2qIJqRJWHRA7jp6zA_Q',
  },
  MIXPANEL: {
    keys: {
      confluence: 'appsplus-mixpanel-confluence',
      jira: 'appsplus-mixpanel-jira',
    },
    marketplace: {
      confluence: 1225982,
      jira: 1225983,
    },
    title: 'Mixpanel',
    domain: ['mixpanel.com'],
    color: '#4F44E0',
    homepage: 'https://www.mixpanel.com',
    placeholder: 'https://mixpanel.com/s/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [Mixpanel] dashboard or report',
      'Click top-right link icon to copy URL',
      'Paste link above',
    ],
    scribe: null,
  },
  MOCKITT: {
    keys: {
      confluence: 'appsplus-mockitt-confluence',
      jira: 'appsplus-mockitt-jira',
    },
    marketplace: {
      confluence: 1226308,
      jira: 1226309,
    },
    title: 'Mockitt',
    domain: ['mockittapp.wondershare.com'],
    color: '#4F03AD',
    docs: 'https://mockitt.wondershare.com/guide/share-the-project-with-others.html',
    placeholder: 'https://mockittapp.wondershare.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('/embed')
        ? `${x.url.replace(/\?.*$/, '').replace(/#.*$/, '')}/embed/v2`
        : x.url,
    tutorial: ['Open your project', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MOCKPLUS: {
    keys: {
      confluence: 'appsplus-mockplus-confluence',
      jira: 'appsplus-mockplus-jira',
    },
    marketplace: {
      confluence: 1226454,
      jira: 1226455,
    },
    title: 'Mockplus',
    domain: ['mockplus.'],
    color: '#EC4163',
    docs: 'https://help.mockplus.com/p/286',
    placeholder: 'https://app.mockplus.com/e/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your project',
      'Click "Share" icon',
      'Copy "Embed project" link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MONDAY: {
    keys: {
      confluence: 'appsplus-monday-confluence',
      jira: 'appsplus-monday-jira',
    },
    marketplace: {
      confluence: 1225473,
      jira: 1225979,
    },
    title: 'Monday.com',
    domain: ['monday.com'],
    requires: 'view.monday.com',
    color: '#FB275D',
    homepage: 'https://www.monday.com',
    placeholder: 'https://view.monday.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('.com/embed')
        ? `${x.url.replace('.com', '.com/embed')}`
        : x.url,
    tutorial: [
      'Open [Monday] board, hover on board title',
      'Click the ellipsis, then "Share"',
      'Copy "Embed code"',
    ],
    scribe: null,
  },
  MOQUPS: {
    keys: {
      confluence: 'appsplus-moqups-confluence',
      jira: 'appsplus-moqups-jira',
    },
    marketplace: {
      confluence: 1225984,
      jira: 1225985,
    },
    title: 'Moqups',
    domain: ['moqups.com'],
    color: '#1089F2',
    docs: 'https://support.moqups.com/hc/en-us/articles/360011471899-Sharing-Project-Links',
    placeholder: 'https://app.moqups.com/[...]',
    embedURL: (x) => `${x.url.replace('/share', '/view')}?fit_width=1`,
    tutorial: [
      'Open your project',
      'Click "Sharing" icon',
      'Click "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  MURAL: {
    keys: {
      confluence: 'appsplus-mural-confluence',
      jira: 'appsplus-mural-jira',
    },
    marketplace: {
      confluence: 1225986,
      jira: 1225987,
    },
    title: 'Mural',
    domain: ['mural.co'],
    requires: 'mural.co/embed',
    color: '#FF4B4B',
    homepage: 'https://www.mural.co',
    placeholder: 'https://app.mural.co/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [Mural] canvas and click "Share"',
      '"Manage access and settings" then "Embed" tab',
      'Enable, copy embed code and paste above',
    ],
    scribe: null,
  },
  NETLIFY: {
    keys: {
      confluence: 'appsplus-netlify-confluence',
      jira: 'appsplus-netlify-jira',
    },
    marketplace: {
      confluence: 1225988,
      jira: 1225989,
    },
    title: 'Netlify',
    domain: ['netlify.app'],
    color: '#00C7B7',
    docs: 'https://docs.netlify.com',
    placeholder: 'https://[...].netlify.app',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your hosted Netlify website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  NOTION: {
    keys: {
      confluence: 'appsplus-notion-confluence',
      jira: 'appsplus-notion-jira',
    },
    marketplace: {
      confluence: 1228890,
      jira: 1228889,
    },
    title: 'Notion',
    domain: ['notion.s'],
    color: '#000000',
    homepage: 'https://www.notion.so',
    placeholder: 'https://[...].notion.site/[...]',
    embedURL: (x) =>
      `https://notion.appsplus.co/${x.url
        .replace(/\?.*$/, '')
        .split('/')
        .pop()
        .split('-')
        .pop()}`,
    tutorial: [
      'Open a [Notion] page and click "Share"',
      'Click "Publish" tab, then "Publish to web"',
      'Copy the web link and paste above',
    ],
    scribe: 'eRBnkQxvSha3ZIJRBjlExA',
  },
  NPMCHARTS: {
    keys: {
      confluence: 'appsplus-npmcharts-confluence',
      jira: 'appsplus-npmcharts-jira',
    },
    marketplace: {
      confluence: 1226337,
      jira: 1226338,
    },
    title: 'NPM Charts',
    color: '#D85151',
    embed: {
      packages: ['@forge/cli'],
    },
    cookieSkip: true,
  },
  OCTOPUSDO: {
    keys: {
      confluence: 'appsplus-octopusdo-confluence',
      jira: 'appsplus-octopusdo-jira',
    },
    marketplace: {
      confluence: 1225990,
      jira: 1225991,
    },
    title: 'Octopus.do',
    domain: ['octopus.do'],
    color: '#005FE4',
    docs: 'https://octopus.do/sitemap/support/help',
    placeholder: 'https://octopus.do/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your project', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  OURWORLDINDATA: {
    keys: {
      confluence: 'appsplus-ourworldindata-confluence',
      jira: 'appsplus-ourworldindata-jira',
    },
    marketplace: {
      confluence: 1225992,
      jira: 1225993,
    },
    title: 'Our World in Data',
    domain: ['ourworldindata.org'],
    color: '#002147',
    docs: 'https://ourworldindata.org/how-to-embed',
    placeholder: 'https://ourworldindata.org/grapher/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open an Our World in Data graph',
      'Click the "Share" icon, then "Copy link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  OVERFLOW: {
    keys: {
      confluence: 'appsplus-overflow-confluence',
      jira: 'appsplus-overflow-jira',
    },
    marketplace: {
      confluence: 1225994,
      jira: 1225995,
    },
    title: 'Overflow',
    domain: ['overflow.io'],
    color: '#2C2C96',
    docs: 'https://support.overflow.io/hc/en-us/articles/360002482893-How-can-I-share-my-Overflow-documents-',
    placeholder: 'https://overflow.io/s/[...]',
    embedURL: (x) => `${x.url.replace('.io/s', '.io/embed')}`,
    tutorial: [
      'Open your Overflow project',
      'Click "Document Shares" icon',
      'Click "New Share", "Upload", "Copy Link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PAPERFORM: {
    keys: {
      confluence: 'appsplus-paperform-confluence',
      jira: 'appsplus-paperform-jira',
    },
    marketplace: {
      confluence: 1225996,
      jira: 1225997,
    },
    title: 'Paperform',
    domain: ['paperform.co'],
    color: '#0569FF',
    docs: 'https://paperform.co/help/articles/how-do-i-share-my-form/',
    placeholder: 'https://[..].paperform.co',
    embedURL: (x) => `${x.url}?embed=1&takeover=0&inline=1&popup=0&_in=0`,
    tutorial: ['Open your form', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PITCH: {
    keys: {
      confluence: 'appsplus-pitch-confluence',
      jira: 'appsplus-pitch-jira',
    },
    marketplace: {
      confluence: 1225998,
      jira: 1225999,
    },
    title: 'Pitch',
    domain: ['pitch.com'],
    color: '#334AC0',
    docs: 'https://help.pitch.com/en/articles/3748913-enable-public-access-to-a-presentation',
    placeholder: 'https://pitch.com/[..]',
    embedURL: (x) =>
      !x.url.includes('/embed-link/')
        ? `https://pitch.com/embed-link/${x.url.split('-').pop()}`
        : x.url,
    tutorial: [
      'Open your presentation',
      'Click "Share" then "Share externally"',
      'Create and copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PLOTLY: {
    keys: {
      confluence: 'appsplus-plotly-confluence',
      jira: 'appsplus-plotly-jira',
    },
    marketplace: {
      confluence: 1226000,
      jira: 1226001,
    },
    title: 'Plotly',
    domain: ['plotly.com'],
    color: '#3F4F75',
    docs: 'https://plotly.com/chart-studio-help/embed-graphs-in-websites/',
    placeholder: 'https://plotly.com/[..]',
    embed: {
      link: false,
      modebar: false,
      logo: false,
    },
    embedURL: (x) =>
      `${
        !x.url?.includes('.embed') ? `${x.url}.embed` : x.url
      }${Helpers.encodeParams(x, true)}`,
    tutorial: ['Open your graph', 'Click "Share" icon', 'Copy embed code'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PREZI: {
    keys: {
      confluence: 'appsplus-prezi-confluence',
      jira: 'appsplus-prezi-jira',
    },
    marketplace: {
      confluence: 1226002,
      jira: 1226003,
    },
    title: 'Prezi',
    domain: ['prezi.com'],
    color: '#3181FF',
    docs: 'https://support.prezi.com/hc/en-us/articles/360003498633-Sharing-a-presentation-s-view-link',
    placeholder: 'https://prezi.com/p/[..]',
    embedURL: (x) =>
      `${
        !x.url?.includes('/embed')
          ? `${x.url
              .replace(/\?.*$/, '')
              .replace(/\/$/, '')
              .replace('/edit/', '/')
              .replace('/i/view/', '/i/')
              .replace('/i/', '/i/embed/')
              .replace('/v/view/', '/v/')
              .replace('/v/', '/v/embed/')
              .replace('/p/', '/embed/')
              .replace('/view/', '/p/embed/')}`
          : x.url
      }`,
    tutorial: [
      'Open your Prezi',
      'Click "Share", then "Copy link"',
      'Or copy link from browser bar',
    ],
    scribe: null,
  },
  PRODPAD: {
    keys: {
      confluence: 'appsplus-propad-confluence',
      jira: 'appsplus-propad-jira',
    },
    marketplace: {
      confluence: 1226004,
      jira: 1226005,
    },
    title: 'ProdPad',
    domain: ['prodpad.com'],
    color: '#25A7D9',
    docs: 'https://help.prodpad.com/article/555-roadmap-publishing-app',
    placeholder: 'https://roadmap.prodpad.com/[..]',
    embedURL: (x) => x.url,
    tutorial: [
      'Click "Apps" icon, then "Roadmap Publishing"',
      'Create "New Published Roadmap"',
      'Click "Publishing Options", copy "Share Link"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PRODUCTBOARD: {
    keys: {
      confluence: 'appsplus-productboard-confluence',
      jira: 'appsplus-productboard-jira',
    },
    marketplace: {
      confluence: 1226006,
      jira: 1226007,
    },
    title: 'Productboard',
    domain: ['productboard.com'],
    color: '#0569FF',
    docs: 'https://support.productboard.com/hc/en-us/articles/360058173373-Embed-your-Portal',
    placeholder: 'https://portal.productboard.com/[...]',
    embed: {
      hide_logo: 1,
      hide_header: 1,
    },
    embedURL: (x) => `${x.url}${Helpers.encodeParams(x)}`,
    tutorial: [
      'Roadmap: "Share" then "Share publicly"',
      'Portal: "Share" then "Embed"',
      'Copy link or embed code',
    ],
    scribe: null,
  },
  PRODUCTPLAN: {
    keys: {
      confluence: 'appsplus-productplan-confluence',
      jira: 'appsplus-productplan-jira',
    },
    marketplace: {
      confluence: 1226008,
      jira: 1226009,
    },
    title: 'ProductPlan',
    domain: ['productplan.com'],
    color: '#0757AA',
    homepage: 'https://www.productplan.com',
    placeholder: 'https://app.productplan.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [ProductPlan] roadmap and click "Share"',
      'Select roadmap from "Private link" dropdown',
      'Click "Copy link" and paste above',
    ],
    scribe: 'KsFFR7iLRXqKbQdCrO9d8A',
  },
  PROTOIO: {
    keys: {
      confluence: 'appsplus-protoio-confluence',
      jira: 'appsplus-protoio-jira',
    },
    marketplace: {
      confluence: 1226010,
      jira: 1226011,
    },
    title: 'Proto.io',
    domain: ['pr.to', 'proto.io'],
    color: '#2C2C96',
    docs: 'https://support.proto.io/hc/en-us/articles/360062483531-Sharing-your-first-project',
    placeholder: 'https://pr.to/[...]',
    embedURL: (x) => `${x.url}/embed?embedside=dark`,
    tutorial: [
      'Open your project, click "Share"',
      'Click "New share link"',
      'Copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  PROTOPIE: {
    keys: {
      confluence: 'appsplus-protopie-confluence',
      jira: 'appsplus-protopie-jira',
    },
    marketplace: {
      confluence: 1226012,
      jira: 1226013,
    },
    title: 'ProtoPie',
    domain: ['protopie.io'],
    color: '#FF5956',
    docs: 'https://www.protopie.io/learn/docs/cloud/sharing-prototypes',
    placeholder: 'https://cloud.protopie.io/p/[...]',
    embed: {
      touchHint: true,
      ui: true,
      scaleToFit: true,
      cursorType: 'touch',
      mockup: true,
    },
    embedURL: (x) => `${x.url}${Helpers.encodeParams(x)}`,
    tutorial: [
      'Open your ProtoPie project',
      'Click "Upload" icon',
      'Then copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  README: {
    keys: {
      confluence: 'appsplus-readme-confluence',
      jira: 'appsplus-readme-jira',
    },
    marketplace: {
      confluence: 1226014,
      jira: 1226015,
    },
    title: 'ReadMe',
    domain: ['readme.io'],
    color: '#018EF5',
    docs: 'https://readme.com/documentation',
    placeholder: 'https://[...].readme.io',
    embedURL: (x) => x.url,
    tutorial: [
      'Allow iFrames in settings',
      'Open your ReadMe docs',
      'Copy link from browser bar',
    ],
    note: 'iFrame setting under Advanced in Custom Domain',
    scribe: null,
  },
  RENDER: {
    keys: {
      confluence: 'appsplus-render-confluence',
      jira: 'appsplus-render-jira',
    },
    marketplace: {
      confluence: 1226016,
      jira: 1226017,
    },
    title: 'Render',
    domain: ['onrender.com'],
    color: '#46E3B7',
    docs: 'https://render.com/docs',
    placeholder: 'https://[...].onrender.com',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your hosted Render website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  REPLIT: {
    keys: {
      confluence: 'appsplus-replit-confluence',
      jira: 'appsplus-replit-jira',
    },
    marketplace: {
      confluence: 1226018,
      jira: 1226019,
    },
    title: 'Replit',
    domain: ['replit.com'],
    color: '#667881',
    docs: 'https://docs.replit.com/hosting/embedding-repls',
    placeholder: 'https://replit.com/[...]',
    embed: {
      outputonly: false,
      embed: false,
    },
    embedURL: (x) =>
      `${x.url.replace(/#.*$/, '')}${Helpers.encodeParams({
        ...x,
        lite: true,
      })}`,
    tutorial: [
      'Open your Replit',
      'Copy link from the browser bar',
      'Configure options in sidebar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ROADMUNK: {
    keys: {
      confluence: 'appsplus-roadmunk-confluence',
      jira: 'appsplus-roadmunk-jira',
    },
    marketplace: {
      confluence: 1226020,
      jira: 1226021,
    },
    title: 'Roadmunk',
    domain: ['roadmunk.com'],
    color: '#FF7B57',
    docs: 'https://support.roadmunk.com/hc/en-us/articles/360044355734-Publish-Roadmaps-to-URL-PNG-or-HTML',
    placeholder: 'https://[...].roadmunk.com/publish/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Roadmunk roadmap',
      'Click "Share" icon, then "Export to URL"',
      'On "URL" tab, "Publish to URL" then copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ROWS: {
    keys: {
      confluence: 'appsplus-rows-confluence',
      jira: 'appsplus-rows-jira',
    },
    marketplace: {
      confluence: 1229627,
      jira: 1229628,
    },
    title: 'Rows',
    domain: ['rows.com'],
    color: '#FFC800',
    docs: 'https://rows.com/docs/cs-embed',
    placeholder: 'https://rows.com/embed/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Rows sheet or chart',
      'Click "Share", then "Embed" tab',
      'Click "Copy URL"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  RSS: {
    keys: {
      confluence: 'appsplus-rss-confluence',
      jira: 'appsplus-rss-jira',
    },
    marketplace: {
      confluence: 1231050,
      jira: 1231051,
    },
    title: 'RSS Reader',
    domain: ['.rss', '.xml'],
    color: '#FFA500',
    placeholder: 'https://[...].rss',
    embedURL: (x) => x.url,
    tutorial: ['Copy RSS feed link', 'Paste above'],
    scribe: null,
  },
  SAVVYCAL: {
    keys: {
      confluence: 'appsplus-savvycal-confluence',
      jira: 'appsplus-savvycal-jira',
    },
    marketplace: {
      confluence: 1226022,
      jira: 1226023,
    },
    title: 'SavvyCal',
    domain: ['savvycal.com'],
    color: '#FACA15',
    docs: 'https://docs.savvycal.com/article/6-embedding-links-on-your-website',
    placeholder: 'https://savvycal.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your SavvyCal booking page', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SCRIBD: {
    keys: {
      confluence: 'appsplus-scribd-confluence',
      jira: 'appsplus-scribd-jira',
    },
    marketplace: {
      confluence: 1226024,
      jira: 1226025,
    },
    title: 'Scribd',
    domain: ['scribd.com'],
    color: '#1A7BBA',
    docs: 'https://support.scribd.com/hc/en-us/articles/210134766-Embedding-documents',
    placeholder: 'https://www.scribd.com/document/[...]',
    embed: {
      start_page: 1,
      view_mode: 'scroll',
      access_key: null,
    },
    embedURL: (x) =>
      !x.url?.includes('/embeds/')
        ? `${x.url
            .replace('/document/', '/embeds/')
            .replace(/[^/]+$/, '')}content${Helpers.encodeParams(x)}`
        : x.url,
    cookieSkip: true,
    tutorial: ['Open a Scribd document', 'Click "Share"', 'Click "Copy Link"'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SCRIBE: {
    keys: {
      confluence: 'appsplus-scribe-confluence',
      jira: 'appsplus-scribe-jira',
    },
    marketplace: {
      confluence: 1229411,
      jira: 1229412,
    },
    title: 'Scribe',
    domain: ['scribehow.com'],
    color: '#FF5466',
    docs: 'https://scribehow.com/shared/How_to_share_your_Scribe_Doc_with_others__9tYvMNIAQp-f0DLABiRRRg',
    placeholder: 'https://scribehow.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('embed/')
        ? x.url.replace('/page/', '/page-embed/').replace('/shared/', '/embed/')
        : x.url,
    tutorial: ['Open a Scribe or Page', 'Click "Share"', 'Click "Copy Link"'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SKETCH: {
    keys: {
      confluence: 'appsplus-sketch-confluence',
      jira: 'appsplus-sketch-jira',
    },
    marketplace: {
      confluence: 1226026,
      jira: 1226027,
    },
    title: 'Sketch',
    domain: ['sketch.com'],
    color: '#F7B500',
    homepage: 'https://www.sketch.com',
    placeholder: 'https://www.sketch.com/s/[...]',
    embedURL: (x) => `${x.url.replace('.com', '.com/embed')}`,
    tutorial: [
      'Open your [Sketch] document',
      'Click "Share", set permissions',
      'Click "Copy Link"',
    ],
    scribe: null,
  },
  SKETCHFAB: {
    keys: {
      confluence: 'appsplus-sketchfab-confluence',
      jira: 'appsplus-sketchfab-jira',
    },
    marketplace: {
      confluence: 1226706,
      jira: 1226707,
    },
    title: 'Sketchfab',
    domain: ['sketchfab.com'],
    color: '#1CAAD9',
    docs: 'https://help.sketchfab.com/hc/en-us/sections/200508566-Share-Embed',
    placeholder: 'https://sketchfab.com/[...]',
    embedURL: (x) => (!x.url?.includes('/embed') ? `${x.url}/embed` : x.url),
    tutorial: ['Open a Sketchfab model', 'Copy link from the browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SKETCHUP: {
    keys: {
      confluence: 'appsplus-sketchup-confluence',
      jira: 'appsplus-sketchup-jira',
    },
    marketplace: {
      confluence: 1226708,
      jira: 1226709,
    },
    title: 'SketchUp',
    domain: ['sketchup.com'],
    color: '#005F9E',
    docs: 'https://help.sketchup.com/en/3d-warehouse/sharing-model-website-or-social-media',
    placeholder: 'https://3dwarehouse.sketchup.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('/embed/')
        ? `https://3dwarehouse.sketchup.com/embed/${
            x.url.match(
              /[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}/,
              'g'
            )?.[0]
          }`
        : x.url,
    tutorial: [
      'Upload your model to 3D Warehouse',
      'Open the model on 3D Warehouse',
      'Copy link from the browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SLIDESHARE: {
    keys: {
      confluence: 'appsplus-slideshare-confluence',
      jira: 'appsplus-slideshare-jira',
    },
    marketplace: {
      confluence: 1226028,
      jira: 1226029,
    },
    title: 'SlideShare',
    domain: ['slideshare.net/slideshow'],
    color: '#008ED2',
    docs: 'https://support.scribd.com/hc/en-us/articles/210134766-Embedding-documents',
    placeholder: 'https://slideshare.net/slideshow/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open a presentation', 'Click "Share" icon', 'Copy embed code'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SLIDO: {
    keys: {
      confluence: 'appsplus-slido-confluence',
      jira: 'appsplus-slido-jira',
    },
    marketplace: {
      confluence: 1229819,
      jira: 1229820,
    },
    title: 'Slido',
    domain: ['sli.do'],
    color: '#39AC37',
    docs: 'https://community.sli.do/running-a-slido-event-81/share-a-link-to-your-event-survey-or-poll-482',
    placeholder: 'https://app.sli.do/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your event, survey or poll',
      'Click "Share" button top right',
      'Then "Share link with participants"',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  SMARTSHEET: {
    keys: {
      confluence: 'appsplus-smartsheet-confluence',
      jira: 'appsplus-smartsheet-jira',
    },
    marketplace: {
      confluence: 1226030,
      jira: 1226031,
    },
    title: 'Smartsheet',
    domain: ['smartsheet.com'],
    requires: 'publish',
    color: '#9AAA83',
    docs: 'https://help.smartsheet.com/articles/522078-publishing-smartsheet-items',
    placeholder: 'https://app.smartsheet.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your sheet, report or dashboard',
      'Click "Publish" icon in right sidebar',
      'Select an option then copy the link',
    ],
    note: 'Only published links will work',
    scribe: null,
  },
  SPOTIFY: {
    keys: {
      confluence: 'appsplus-spotify-confluence',
      jira: 'appsplus-spotify-jira',
    },
    marketplace: {
      confluence: 1229754,
      jira: 1229753,
    },
    title: 'Spotify',
    domain: ['spotify.com'],
    color: '#1DB954',
    docs: 'https://artists.spotify.com/en/help/article/embedded-players',
    placeholder: 'https://open.spotify.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open profile, album, song, playlist',
      'Click triple dot, "Share", then "Embed"',
      'Click "Copy" button',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  STATUSPAGE: {
    keys: {
      confluence: 'appsplus-statuspage-confluence',
      jira: 'appsplus-statuspage-jira',
    },
    marketplace: {
      confluence: 1226032,
      jira: 1226033,
    },
    title: 'Statuspage',
    domain: ['statuspage.io', 'status.'],
    color: '#172B4D',
    docs: 'https://support.atlassian.com/statuspage/docs/read-the-statuspage-user-guide/',
    placeholder: 'https://[...].statuspage.io',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your published Statuspage',
      'Ensure it is publicly accessible',
      'Copy link from browser bar',
    ],
    note: 'Only public status pages will work',
    scribe: null,
  },
  STORIESONBOARD: {
    keys: {
      confluence: 'appsplus-storiesonboard-confluence',
      jira: 'appsplus-storiesonboard-jira',
    },
    marketplace: {
      confluence: 1226320,
      jira: 1226321,
    },
    title: 'StoriesOnBoard',
    domain: ['storiesonboard.com'],
    color: '#283660',
    docs: 'https://docs.storiesonboard.com/en/articles/1155735-share-and-invite',
    placeholder: 'https://[...].storiesonboard.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your shared story map',
      'Copy browser bar link and paste above',
      'Classic: "Share", more options, enable private link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  STORYBOOK: {
    keys: {
      confluence: 'appsplus-storybook-confluence',
      jira: 'appsplus-storybook-jira',
    },
    marketplace: {
      confluence: 1227425,
      jira: 1227426,
    },
    title: 'Storybook',
    domain: ['chromatic.com', 'storybook'],
    color: '#FF4785',
    docs: 'https://www.chromatic.com/docs/embed',
    placeholder: 'https://[...].chromatic.com/[...]',
    embed: {
      toolbar: true,
    },
    embedURL: (x) =>
      `${
        !x.toolbar ? x.url.replace('.com/', '.com/iframe.html') : x.url
      }&viewMode=story&shortcuts=false&singleStory=true`,
    tutorial: [
      'Open a component hosted on chromatic.com',
      'Hover and click "View Storybook"',
      'Copy link from browser bar (inc ?path=)',
    ],
    note: 'Only public Storybook links will work',
    scribe: null,
  },
  SURVEYMONKEY: {
    keys: {
      confluence: 'appsplus-surveymonkey-confluence',
      jira: 'appsplus-surveymonkey-jira',
    },
    marketplace: {
      confluence: 1226034,
      jira: 1226035,
    },
    title: 'SurveyMonkey',
    domain: ['surveymonkey.'],
    requires: '/r/',
    color: '#00BF6F',
    homepage: 'https://www.surveymonkey.com',
    placeholder: 'https://www.surveymonkey.com/r/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Edit a [SurveyMonkey] survey',
      '"Collect Responses" tab then "Add new collector"',
      'Create "Web link collector" and paste link above',
      'Note: results cannot be embedded',
    ],
    scribe: null,
  },
  SURVEYSPARROW: {
    keys: {
      confluence: 'appsplus-surveysparrow-confluence',
      jira: 'appsplus-surveysparrow-jira',
    },
    marketplace: {
      confluence: 1226036,
      jira: 1226037,
    },
    title: 'SurveySparrow',
    titleEditor: 'Embed SurveySparrow',
    domain: ['surveysparrow.com', 'sprw.io'],
    color: '#13C4A3',
    homepage: 'https://www.surveysparrow.com',
    placeholder: 'https://sprw.io/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Edit a [SurveySparrow] survey',
      'Click top "Share" tab',
      'Copy URL and paste above',
    ],
    scribe: null,
  },
  SWAGGER: {
    keys: {
      confluence: 'appsplus-swagger-confluence',
      jira: 'appsplus-swagger-jira',
    },
    marketplace: {
      confluence: 1226038,
      jira: 1226039,
    },
    title: 'Swagger UI',
    domain: ['swagger', 'openapi'],
    attachments: ['.json', '.yaml'],
    color: '#85EA2D',
    docs: 'https://swagger.io/docs',
    placeholder: 'https://[...].swagger.io/v2/swagger.json',
    embed: {
      features: ['title', 'description', 'links', 'schemes', 'authorize'],
      docExpansion: 'list',
      defaultModelExpandDepth: -1,
    },
    embedURL: (x) => {
      if (x.url?.includes('swaggerhub.com')) {
        return x.url
          .replace('app.swaggerhub.com', 'api.swaggerhub.com')
          .replace('/apis-docs/', '/apis/')
      }
      return x.url
    },
    tutorial: [
      'Select attachment in sidebar, or...',
      'Open your hosted JSON/YAML file',
      'Copy link from browser bar',
    ],
    note: 'Only public raw JSON links will work',
    scribe: null,
  },
  TABLEAU: {
    keys: {
      confluence: 'appsplus-tableau-confluence',
      jira: 'appsplus-tableau-jira',
    },
    marketplace: {
      confluence: 1226040,
      jira: 1226041,
    },
    title: 'Tableau Public',
    domain: ['public.tableau.com'],
    color: '#E97627',
    docs: 'https://kb.tableau.com/articles/howto/embedding-tableau-public-views-in-iframes?lang=en-us',
    placeholder: 'https://public.tableau.com/views/[...]',
    embed: {
      ':alerts': 'no',
      ':showShareOptions': 'no',
      ':subscriptions': 'no',
      ':tabs': 'no',
      ':toolbar': 'yes',
      ':tooltip': 'no',
    },
    embedURL: (x) => {
      const url = x.url.replace(/\?.*$/, '')
      return `${url}${Helpers.encodeParams({
        ...x,
        url,
        ':embed': 'yes',
        ':showVizHome': 'no',
      })}`
    },
    tutorial: ['Open Tableau Public view', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  TELLA: {
    keys: {
      confluence: 'appsplus-tella-confluence',
      jira: 'appsplus-tella-jira',
    },
    marketplace: {
      confluence: 1229821,
      jira: 1229822,
    },
    title: 'Tella',
    domain: ['tella.tv'],
    color: '#6051F7',
    homepage: 'https://www.tella.tv',
    placeholder: 'https://www.tella.tv/video/[...]',
    embedURL: (x) =>
      !x.url.includes('/embed') ? x.url.replace('/view', '/embed') : x.url,
    tutorial: [
      'Open a [Tella] video',
      'Click "Share" then "Embed"',
      'Click "Copy code" and paste above',
    ],
    scribe: 'gM2AzecXS5WA0QFQJ5fcIg',
  },
  TIKTOK: {
    keys: {
      confluence: 'appsplus-tiktok-confluence',
      jira: 'appsplus-tiktok-jira',
    },
    marketplace: {
      confluence: 1226042,
      jira: 1226043,
    },
    title: 'TikTok',
    domain: ['tiktok.com'],
    color: '#000000',
    docs: 'https://support.tiktok.com/en/using-tiktok/exploring-videos/sharing',
    placeholder: 'https://tiktok.com/[...]',
    embedURL: (x) => x.url.replace(/\?.*$/, ''),
    tutorial: ['Open a TikTok video', 'Copy link from browser bar'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  TRADINGVIEW: {
    keys: {
      confluence: 'appsplus-tradingview-confluence',
      jira: 'appsplus-tradingview-jira',
    },
    marketplace: {
      confluence: 1226335,
      jira: 1226336,
    },
    title: 'TradingView',
    color: '#000000',
    embed: {
      type: 'overview',
      theme: 'light',
      symbols: [
        {
          label: 'NASDAQ:TEAM',
          value: 'NASDAQ:TEAM',
        },
      ],
    },
    cookieSkip: true,
  },
  TRELLO: {
    keys: {
      confluence: 'appsplus-trello-confluence',
      jira: 'appsplus-trello-jira',
    },
    marketplace: {
      confluence: 1226044,
      jira: 1226045,
    },
    title: 'Trello',
    domain: ['trello.com'],
    color: '#0052CC',
    homepage: 'https://trello.com',
    placeholder: 'https://trello.com/[...]',
    embedURL: (x) => `${x.url.match(/(.*)trello.com\/[b|c]\/\w+/g)?.[0]}.html`,
    tutorial: [
      'Open a [Trello] board or card',
      'Set the visibility to "public"',
      'Copy browser bar link and paste above',
    ],
    scribe: 'NBtxqQ1YQLG9grIpNSNBUw',
  },
  TWITTER: {
    keys: {
      confluence: 'appsplus-twitter-confluence',
      jira: 'appsplus-twitter-jira',
    },
    marketplace: {
      confluence: 1226046,
      jira: 1226047,
    },
    title: 'X/Twitter',
    domain: ['x.com', 'twitter.com'],
    color: '#1DA1F2',
    homepage: 'https://x.com',
    placeholder: 'https://x.com/[...]',
    embed: {
      features: ['header', 'scrollbar'],
    },
    embedURL: (x) => x.url,
    tutorial: [
      'Open an [X] profile or post',
      'Copy link from browser bar',
      'Paste link above',
    ],
    scribe: null,
  },
  TYPEFORM: {
    keys: {
      confluence: 'appsplus-typeform-confluence',
      jira: 'appsplus-typeform-jira',
    },
    marketplace: {
      confluence: 1226048,
      jira: 1226049,
    },
    title: 'Typeform',
    domain: ['typeform.com'],
    color: '#262627',
    docs: 'https://help.typeform.com/hc/en-us/articles/360029249212-Embed-your-typeform',
    placeholder: 'https://[...].typeform.com/to/[...]',
    embed: {
      hideHeaders: false,
      hideFooter: false,
    },
    embedURL: (x) => x.url,
    tutorial: ['Open your form', 'Click "Share"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  VERCEL: {
    keys: {
      confluence: 'appsplus-vercel-confluence',
      jira: 'appsplus-vercel-jira',
    },
    marketplace: {
      confluence: 1226050,
      jira: 1226051,
    },
    title: 'Vercel',
    domain: ['vercel.app'],
    color: '#000000',
    docs: 'https://vercel.com/docs',
    placeholder: 'https://[...].vercel.app',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your hosted Vercel website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  VIDEOASK: {
    keys: {
      confluence: 'appsplus-videoask-confluence',
      jira: 'appsplus-videoask-jira',
    },
    marketplace: {
      confluence: 1226052,
      jira: 1226053,
    },
    title: 'VideoAsk',
    domain: ['videoask.com'],
    color: '#F73A4A',
    docs: 'https://www.videoask.com/help/sharing/360036300731-share-your-videoask',
    placeholder: 'https://www.videoask.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your video', 'Click "Share" icon', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  VIDYARD: {
    keys: {
      confluence: 'appsplus-vidyard-confluence',
      jira: 'appsplus-vidyard-jira',
    },
    marketplace: {
      confluence: 1229823,
      jira: 1229824,
    },
    title: 'Vidyard',
    domain: ['vidyard.com'],
    color: '#46DB83',
    docs: 'https://knowledge.vidyard.com/hc/en-us/articles/360023054254-How-to-share-a-link-to-your-video',
    placeholder: 'https://share.vidyard.com/[...]',
    embedURL: (x) =>
      !x.url.includes('play.vidyard.com')
        ? x.url.replace('share.vidyard.com/watch', 'play.vidyard.com')
        : x.url,
    tutorial: [
      'Open your video',
      'Enable "Embed on a site"',
      'Click "Copy Link" (not code)',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  VIMEO: {
    keys: {
      confluence: 'appsplus-vimeo-confluence',
      jira: 'appsplus-vimeo-jira',
    },
    marketplace: {
      confluence: 1226054,
      jira: 1226055,
    },
    title: 'Vimeo',
    domain: ['vimeo.com'],
    color: '#1AB7EA',
    docs: 'https://vimeo.zendesk.com/hc/en-us/articles/229326167-Share-features',
    placeholder: 'https://vimeo.com/[...]',
    embed: {
      autoplay: 0,
      color: '#ffffff',
      background: '#000000',
      title: 0,
      byline: 0,
      portrait: 0,
    },
    embedURL: (x) => {
      const url = !x.url.includes('player.vimeo.com')
        ? x.url.replace('vimeo.com', 'player.vimeo.com/video')
        : x.url
      return `${url}${Helpers.encodeParams(x, true, [
        'url',
        'background',
      ]).replace(/%23/g, '')}`
    },
    tutorial: [
      'Open public or private Vimeo video',
      'Copy link from the browser bar',
      'Or click "Share" then copy "Embed" code',
    ],
    note: 'Must be set to "embed anywhere" in settings',
    scribe: null,
  },
  VISME: {
    keys: {
      confluence: 'appsplus-visme-confluence',
      jira: 'appsplus-visme-jira',
    },
    marketplace: {
      confluence: 1226056,
      jira: 1226057,
    },
    title: 'VisMe',
    domain: ['visme.co'],
    color: '#3CACD7',
    docs: 'https://support.visme.co/share-and-publish-to-the-web/',
    placeholder: 'https://my.visme.co/view/[...]',
    embedURL: (x) =>
      `${x.url.replace('visme.co/view', 'visme.co/_embed')}?responsive=1`,
    tutorial: [
      'Open your Visme project',
      'Click "Share", then publish',
      'Copy published link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  WEBFLOW: {
    keys: {
      confluence: 'appsplus-webflow-confluence',
      jira: 'appsplus-webflow-jira',
    },
    marketplace: {
      confluence: 1226058,
      jira: 1226059,
    },
    title: 'Webflow',
    domain: ['webflow.io', 'webflow.com'],
    color: '#4353FF',
    docs: 'https://webflow.com/blog/webflow-tutorial',
    placeholder: 'https://[...].webflow.io',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your public Webflow website',
      'Copy link from the browser bar',
    ],
    note: 'Link must be HTTPS',
    scribe: null,
  },
  WHIMSICAL: {
    keys: {
      confluence: 'appsplus-whimsical-confluence',
      jira: 'appsplus-whimsical-jira',
    },
    marketplace: {
      confluence: 1226060,
      jira: 1226061,
    },
    title: 'Whimsical',
    titleEditor: 'Embed Whimsical',
    domain: ['whimsical.com'],
    color: '#8313DD',
    homepage: 'https://www.whimsical.com',
    placeholder: 'https://whimsical.com/[...]',
    embedURL: (x) =>
      !x.url?.includes('.com/embed')
        ? `https://whimsical.com/embed/${x.url
            .split(x.url?.includes('-') ? '-' : '/')
            .pop()}`
        : x.url,
    tutorial: ['Open your [Whimsical] board', 'Click "Share" then "Copy Link"'],
    scribe: null,
  },
  WOOPRA: {
    keys: {
      confluence: 'appsplus-woopra-confluence',
      jira: 'appsplus-woopra-jira',
    },
    marketplace: {
      confluence: 1226062,
      jira: 1226063,
    },
    title: 'Woopra',
    domain: ['snapshot.woopra.com'],
    color: '#2F93F2',
    docs: 'https://docs.woopra.com/docs/sharing-reports',
    placeholder: 'https://snapshot.woopra.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a Woopra report',
      'Click three dots, then "Snapshot"',
      'Copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  WRIKE: {
    keys: {
      confluence: 'appsplus-wrike-confluence',
      jira: 'appsplus-wrike-jira',
    },
    marketplace: {
      confluence: 1226064,
      jira: 1226065,
    },
    title: 'Wrike',
    domain: ['wrike.com'],
    requires: 'frontend',
    color: '#04454D',
    docs: 'https://help.wrike.com/hc/en-us/articles/210323545-Gantt-Chart-Snapshots',
    placeholder: 'https://www.wrike.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a Gantt chart, click "Snapshots"',
      'Click "From current state"',
      'Copy link',
    ],
    note: 'Currently only works for Gantt charts',
    scribe: null,
  },
  WUFOO: {
    keys: {
      confluence: 'appsplus-wufoo-confluence',
      jira: 'appsplus-wufoo-jira',
    },
    marketplace: {
      confluence: 1226066,
      jira: 1226067,
    },
    title: 'Wufoo',
    domain: ['wufoo.com'],
    color: '#E86F69',
    docs: 'https://help.wufoo.com/articles/en_US/kb/Form-Links',
    placeholder: 'https://[...].wufoo.com/forms/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Open your form', 'Click "Share form"', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  YOUTUBE: {
    keys: {
      confluence: 'appsplus-youtube-confluence',
      jira: 'appsplus-youtube-jira',
    },
    marketplace: {
      confluence: 1226070,
      jira: 1226071,
    },
    title: 'YouTube',
    domain: ['youtube.com', 'youtu.be'],
    color: '#FF0000',
    docs: 'https://support.google.com/youtube/answer/57741?hl=en',
    placeholder: 'https://youtube.com/[...]',
    embed: {
      autoplay: 0,
      cc_load_policy: 0,
      controls: 1,
      modestbranding: 0,
      start: 0,
      end: null,
    },
    embedURL: (x) => {
      let url = x.url.replace('https://music.', 'https://')
      url = url.includes('.com/playlist')
        ? url.replace('.com/playlist', '.com/embed/videoseries')
        : url
            .replace('.be/', 'be.com/watch?v=')
            .replace('.com/watch?v=', '.com/embed/')
            .replace(/&.*$/, '')
      return `${url}${Helpers.encodeParams({
        ...x,
        url,
      })}`
    },
    tutorial: [
      'Open a YouTube video or playlist',
      'Copy link from the browser bar',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZEPLIN: {
    keys: {
      confluence: 'appsplus-zeplin-confluence',
      jira: 'appsplus-zeplin-jira',
    },
    marketplace: {
      confluence: 1226072,
      jira: 1226073,
    },
    title: 'Zeplin',
    domain: ['zpl.io', 'zeplin.io'],
    color: '#EE6723',
    homepage: 'https://zeplin.io',
    placeholder: 'https://zpl.io/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your [Zeplin] design',
      'Screens: copy link in browser bar',
      'Projects: "Share", enable "Scene", "Copy link"',
    ],
    scribe: null,
  },
  ZOHOANALYTICS: {
    keys: {
      confluence: 'appsplus-zoho-analytics-confluence',
      jira: 'appsplus-zoho-analytics-jira',
    },
    marketplace: {
      confluence: 1226074,
      jira: 1226075,
    },
    title: 'Zoho Analytics',
    domain: ['analytics.zoho.', 'analytics.zohopublic.'],
    color: '#5B69F5',
    homepage: 'https://analytics.zoho.com',
    placeholder: 'https://analytics.zoho.com/open-view/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open a [Zoho Analytics] report',
      'Click "Share" then "Embed"',
      'Copy embed code and paste above',
    ],
    scribe: null,
  },
  ZOHOCRM: {
    keys: {
      confluence: 'appsplus-zoho-crm-confluence',
      jira: 'appsplus-zoho-crm-jira',
    },
    marketplace: {
      confluence: 1228745,
      jira: 1228744,
    },
    title: 'Zoho CRM',
    domain: ['crm.zoho.', 'crm.zohopublic.'],
    color: '#0053CD',
    docs: 'https://help.zoho.com/portal/en/kb/crm/analytics-and-dashboards/analytics-or-dashboards/articles/create-dashboard#Embed_URL',
    placeholder: 'https://crm.zoho.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open Zoho CRM, click "Analytics" tab',
      'Click triple dot on component, then "Embed URL"',
      'Add "appsplus.co" to allowed domains, then copy URL',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZOHODOCS: {
    keys: {
      confluence: 'appsplus-zoho-docs-confluence',
      jira: 'appsplus-zoho-docs-jira',
    },
    marketplace: {
      confluence: 1226076,
      jira: 1226077,
    },
    title: 'Zoho Docs',
    domain: ['docs.zoho.', 'docs.zohopublic.'],
    color: '#C8202B',
    docs: 'https://www.zoho.com/docs/help/secure-sharing.html',
    placeholder: 'https://docs.zoho.com/file/[...]',
    embedURL: (x) => `${x.url.replace('/file/', '/embed/')}`,
    tutorial: ['Open your file', 'Click "Share"', 'Copy link'],
    note: 'Only public or published links will work',
    scribe: null,
  },
  ZOHOFORMS: {
    keys: {
      confluence: 'appsplus-zoho-forms-confluence',
      jira: 'appsplus-zoho-forms-jira',
    },
    marketplace: {
      confluence: 1226078,
      jira: 1226079,
    },
    title: 'Zoho Forms',
    domain: ['forms.zoho.', 'forms.zohopublic.'],
    color: '#1C222D',
    docs: 'https://www.zoho.com/forms/share.html',
    placeholder: 'https://forms.zoho.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Find your form', 'Click "Share" icon', 'Copy "Form Permalink"'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZOHOMEETING: {
    keys: {
      confluence: 'appsplus-zoho-meeting-confluence',
      jira: 'appsplus-zoho-meeting-jira',
    },
    marketplace: {
      confluence: 1226080,
      jira: 1226081,
    },
    title: 'Zoho Meeting',
    domain: ['meeting.zoho.', 'meeting.zohopublic.'],
    color: '#226BAC',
    docs: 'https://help.zoho.com/portal/en/kb/meeting/user-guide/meetings/record-a-meeting/articles/record-a-meeting',
    placeholder: 'https://meeting.zoho.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your meeting recording',
      'Click "Share", set to "public access"',
      'Copy link',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZOHOSHEET: {
    keys: {
      confluence: 'appsplus-zoho-sheet-confluence',
      jira: 'appsplus-zoho-sheet-jira',
    },
    marketplace: {
      confluence: 1226082,
      jira: 1226083,
    },
    title: 'Zoho Sheet',
    domain: ['sheet.zoho.', 'sheet.zohopublic.'],
    color: '#36A55D',
    docs: 'https://www.zoho.com/docs/help/sharing-a-spreadsheet.html',
    placeholder: 'https://sheet.zoho.com/[...]',
    embedURL: (x) => `${x.url}${x.url.includes('?') ? '&' : '?'}mode=embed`,
    tutorial: [
      'Open your Zoho Sheet',
      'Click "Share" then "Publish"',
      'Copy "Published Link"',
    ],
    note: 'Only published links will work',
    scribe: null,
  },
  ZOHOSHOW: {
    keys: {
      confluence: 'appsplus-zoho-show-confluence',
      jira: 'appsplus-zoho-show-jira',
    },
    marketplace: {
      confluence: 1226084,
      jira: 1226085,
    },
    title: 'Zoho Show',
    domain: ['show.zoho.', 'show.zohopublic.'],
    color: '#C94038',
    docs: 'https://help.zoho.com/portal/en/kb/show/web-app/publish-and-broadcast/articles/share-and-embed-link-to-published-presentations-zohoshow#Share_a_link_to_published_presentation',
    placeholder: 'https://show.zoho.com/publish/[...]',
    embed: {
      toolbar: false,
      menu: true,
      loop: true,
      viewtype: 2,
    },
    embedURL: (x) => `${x.url}/params${Helpers.encodeParams(x, true)}`,
    tutorial: [
      'Open your presentation',
      'Click "Share" then "Publish"',
      'Copy "Publish Link"',
    ],
    note: 'Only published links will work',
    scribe: null,
  },
  ZOHOSURVEY: {
    keys: {
      confluence: 'appsplus-zoho-survey-confluence',
      jira: 'appsplus-zoho-survey-jira',
    },
    marketplace: {
      confluence: 1226086,
      jira: 1226087,
    },
    title: 'Zoho Survey',
    domain: ['survey.zoho.', 'survey.zohopublic.'],
    color: '#4979EE',
    docs: 'https://www.zoho.com/survey/share-survey-and-reports.html',
    placeholder: 'https://survey.zoho.com/[...]',
    embedURL: (x) => x.url,
    tutorial: ['Edit your survey', 'Scroll to the bottom', 'Copy link'],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZOHOWORKDRIVE: {
    keys: {
      confluence: 'appsplus-zoho-workdrive-confluence',
      jira: 'appsplus-zoho-workdrive-jira',
    },
    marketplace: {
      confluence: 1226088,
      jira: 1226089,
    },
    title: 'Zoho WorkDrive',
    domain: ['workdrive.zoho.', 'workdrive.zohopublic.'],
    color: '#F9C46B',
    docs: 'https://www.zoho.com/workdrive/external-sharing.html',
    placeholder: 'https://workdrive.zoho.com/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Click three dots on file or folder',
      'Click "New embed code"',
      'Copy embed code',
    ],
    note: 'Email us if you need help :)',
    scribe: null,
  },
  ZOHOWRITER: {
    keys: {
      confluence: 'appsplus-zoho-writer-confluence',
      jira: 'appsplus-zoho-writer-jira',
    },
    marketplace: {
      confluence: 1226090,
      jira: 1226091,
    },
    title: 'Zoho Writer',
    domain: ['writer.zoho.', 'writer.zohopublic.'],
    color: '#236EB4',
    docs: 'https://www.zoho.com/writer/help/document-collaboration-and-sharing.html',
    placeholder: 'https://docs.zoho.com/file/[...]',
    embedURL: (x) => x.url,
    tutorial: [
      'Open your Zoho Writer document',
      'Click "File", "Publish" or "Publish Settings"',
      'Select "Public on the web" and copy link',
    ],
    note: 'Only published links will work',
    scribe: null,
  },
  ZOOM: {
    keys: {
      confluence: 'appsplus-zoom-embed-confluence',
      jira: 'appsplus-zoom-embed-jira',
    },
    marketplace: {
      confluence: 1226092,
      jira: 1226093,
    },
    title: 'Zoom',
    domain: ['zoom.us'],
    color: '#2D8CFF',
    homepage: 'https://zoom.us',
    placeholder: 'https://zoom.us/rec/[...]',
    embed: {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'duration',
        'mute',
        'volume',
        'settings',
        'download',
        'fullscreen',
      ],
      autoplay: false,
      muted: false,
      hideControls: true,
      start: 0,
      passcode: null,
    },
    embedURL: (x) => x.url,
    cookieSkip: true,
    tutorial: [
      'Open a [Zoom] recording',
      'Copy link in browser bar, paste above',
      'Add passcode into config if needed',
    ],
    scribe: null,
  },
}

export const apps = {
  ...bundles,
  ...utilities,
  ...standalone,
}
